export const cn_strings = {
  'smartTable.requestReason': '申请原因',
  'smartTable.passportType': '护照类型',
  'err.pattern.^0[1-9]\\d{6,14}$': '号码必须以 0 开头，后跟 1 到 9 的数字，然后是 6 到 14 位数字。',
  'err.pattern.^[A-Za-zÀ-ÖØ-öø-ÿ\' .\-]*$': '该字段只能包含字母、重音符号、空格、撇号、点和连字符。',
  'err.pattern.^[A-Za-zÀ-ÖØ-öø-ÿ0-9\\s\\-\\.\'\(\)]*$': '该字段只能包含字母、数字、重音符号、空格、连字符、点、撇号和括号。',
  'err.pattern.^[A-Za-zÀ-ÖØ-öø-ÿ0-9\' .\(\)\-\\s]+$': '该字段只能包含字母、数字、重音符号、空格、撇号、点、括号和连字符。',
  'err.pattern.^[A-Za-zÀ-ÖØ-öø-ÿ0-9\'.,\(\)\- ]*$': '该字段只能包含字母、数字、重音符号、空格、撇号、逗号、点、括号和连字符。',
  'err.pattern.^[A-Za-zÀ-ÖØ-öø-ÿ0-9\' .\(\)\-]*$': '该字段只能包含字母、数字、重音符号、空格、撇号、点、括号和连字符。',
  'err.pattern.^[A-Za-zÀ-ÖØ-öø-ÿ0-9\' .\(\)\-]+$': '该字段只能包含字母、数字、重音符号、空格、撇号、点、括号和连字符。',
  'tooltip.allNotes': '查看所有备注',
  'tooltip.openDuplicate': '打开最新的重复支付',
  'payment.openDuplicate': '打开该重复项',
  'err.pattern.password': '密码必须包含以下至少两种：小写字母、大写字母、数字或特殊字符。',
  'form.perm1.DYN.': '创建应用程序',
  'global.pay': '支付',
  'BirthCity': '出生城市',
  'err.pattern.^\\+[1-9][0-9]{7,14}$': '字段"{fieldName}"必须以"+"开头，后跟8到15位数字。',
  'smartTable.timeslot': '时间段',
  'refusalReason.desc.DYN.': '<p>请简要说明拒绝的原因。</p>',
  'timezone.notice': '预约时间将根据预约地点的时区安排。',
  'timeslot.noBooking': '尚未进行时间段预订。',
  'timeslot.tooCloseToChange': '您无法再更改此预约，因为它将在 {hours} 小时内开始。',
  'session.inactive.title': '会话已失效',
  'session.inactive': '由于长时间未操作，您的会话已过期。',
  'reactivateSession': '重新激活会话',
  'global.changeTimeSlot': '更改时间段',
  'outUsage.AB': '此申请<b>已超出有效期</b>。请将申请人引导至自助服务机，或协助他们重新提交申请。',
  'outUsage.C': '此申请<b>已超出有效期</b>。请关闭此请求，然后为申请人创建新条目并继续拒绝。',
  'err.payment.notAvailable': '此申请不可用。',
  'form.PlaceOfBirth': '出生地',
  'borderPass': '边境通行证',
  'urgent_pass': '紧急护照',
  'feedback': '反馈',
  'err.mustBeDifferentThan.errorValue': '字段"{fieldName}"必须不同于{errorValue}。',
  'DYN.PASSPORT_WRONG': '错误的护照类型',
  'err.max.errorValue': '字段"{fieldName}"必须小于{errorValue}。',
  'err.max': '字段“{fieldName}”必须小于允许的最大值。',
  'err.min.errorValue': '字段"{fieldName}"必须大于{errorValue}。',
  'err.min': '字段“{fieldName}”必须大于允许的最小值。',
  'updateField.desc': '请为以下字段提供更新信息：<b>{field}</b>',
  'marital.status.engaged': '已婚',
  'payment_status.desc.DYN.passport_booked.toPay': '该文件申请已预订，尚需支付。',
  'payment_status.desc.DYN.passport_booked': '该文件申请已预订并已支付。',
  'place.notExist': '地点不存在',
  'ApplicationForm': '申请表',
  'BirthCertificate': '出生证明',
  'ParentalAuthorization': '家长授权',
  'print.qr.verification': '验证',
  'printSettings.selected': '您正在修改文档的打印设置：<b>{documentName}</b>',
  'print.settings.success': '打印设置已成功更新，适用于文档：<b>{documentName}</b>',
  'error.noHasFace': '照片中未检测到人脸。请重新拍照。',
  'kiosk.redirect': '您的国籍不允许继续使用自助终端模式。请使用账户登录以继续。您将被重定向到登录页面。',
  'err.OtherPurpose.required': '其他原因是必填项',
  'name.warn': '名字和/或姓氏为空或少于2个字符。',
  'print.qr.application': '申请',
  'movements.empty': '目前尚未记录任何动态。',
  'payment.notes': '备注',
  'payment.noNotes': '暂无备注',
  'extension.alreadyExists.warning': '此申请已存在延期。您确定要创建新的延期吗？',
  'payment.addNote.placeholder': '添加备注…',
  'supervision.login.error': '监督员验证失败。',
  'global.seeMore': '显示更多',
  'global.seeLess': '显示更少',
  'err.hostPhone.pattern': '电话号码必须以 +（国家代码）或 0 开头，并包含 7 到 15 位数字。',
  'reprintSticker': '重新打印贴纸',
  'PreviousVisa': '之前的签证',
  'multipleEntry.warning': '注意：多次入境签证仅授予那些过去至少获得过一次有效签证的人。将要求提供之前签证的副本。',
  'err.PreviousVisa.required': '需要之前的签证',
  'ask.downgradeType': '选择目标签证类型',
  'err.approveRefuse.required': '请选择是否推荐。',
  'ask.downgrade.multiple': '您确定要将此签证降级为 {type} 吗？',
  'downgrade.type.label': '目标签证类型',
  'err.daysGranted.min': '天数必须至少为 1',
  'err.daysGranted.max': '天数不能超过所申请的天数。',
  'err.daysGranted.required': '必须填写天数。',
  'approval.daysGranted.error': '请输入有效的天数。',
  'eerr.password.pattern': '密码必须包含以下至少两种：小写字母、大写字母、数字或特殊字符。',
  'err.documentNumber.pattern': '证件号码只能包含字母、数字、空格和连字符。',
  'ask.borderpass': '这真的是边境通行证吗？',
  'err.ExistingValidEntryReference.required': '现有的有效入境参考号是必填项',
  'BirthCountry': '出生地',
  'old': '旧密码',
  'firstName': '名字',
  'email': '电子邮件',
  'paymentMethod': '支付方式',
  'client.extended.softLockedOutLogin30Minutes': '您已被锁定30分钟。请稍后再试。',
  'password': '密码',
  'password2': '确认密码',
  'PreviousConvictions': '定罪记录',
  'Address': '地址',
  'err.err': '错误',
  'err.maxDateMilliFrom.errorValue': '字段"{fieldName}"不能超过由字段"{control}"定义的限制"{errorValue}"。',
  'err.maxDateMilliTo.errorValue': '字段"{fieldName}"必须早于由字段"{control}"定义的限制"{errorValue}"。',
  'err.mustBeEqualOrAfter.errorValue': '字段"{fieldName}"必须等于或晚于字段"{errorValue}"。',
  'err.mustBeEqualOrBefore.errorValue': '字段"{fieldName}"必须等于或早于字段"{errorValue}"。',
  'err.maxDateMilliFromToday.errorValue': '字段"{fieldName}"不能超过{errorValue}。',
  'err.minDateMilliFromNow.errorValue': '字段"{fieldName}"必须是大于或等于{errorValue}的日期。',
  'err.maxDateMilliFromNow.errorValue': '字段"{fieldName}"必须是小于或等于{errorValue}的日期。',
  'err.minDateMilliFromNow': '字段"{fieldName}"必须是大于或等于允许的最小日期。',
  'err.maxDateMilliFromNow': '字段"{fieldName}"必须是小于或等于允许的最大日期。',
  'err.mustMatch': '字段{fieldName}必须与对应字段相同。',
  'err.requireOneOf.errorValue': '{errorValue}必须提供',
  'err.requireOneOf.field': '字段 \'{name}\'',
  'err.requireOneOf.separator': ' 或 ',
  'err.pattern.^[0-9]{6,14}$': '字段"{fieldName}"必须包含6到14个数字。',
  'err.patten.^[0-9A-Za-z\\-\\s]{3,15}$': '字段"{fieldName}"必须包含3到15个字母、数字、连字符或空格。',
  'err.pattern.^[+]?[0-9\\s\\-\\(\\)]{7,20}$': '字段"{fieldName}"必须包含7到20个字符，包括数字、空格、连字符或括号。',
  'err.pattern.^[0-9A-Za-z]{5,20}$': '字段"{fieldName}"必须包含5到20个字母或数字。',
  'err.pattern.^[0-9]{10}$': '字段"{fieldName}"必须正好包含10个数字。',
  'err.pattern.^[0-9A-Za-z]{5,20}': '字段"{fieldName}"必须包含5到20个字母或数字。',
  'err.pattern.^[0-9]{8,20}$': '字段"{fieldName}"必须包含8到20个数字。',
  'err.pattern.^[A-Za-z0-9]{5,15}$': '字段"{fieldName}"必须包含5到15个字母或数字。',
  'err.pattern.^((?:data:image/(jp2|jpeg);base64,)*([A-Za-z0-9+/==]+))': '字段"{fieldName}"必须是一个有效格式的JPEG或JP2格式的Base64编码图像。',
  'err.pattern.^[a-z]$': '字段"{fieldName}"必须只包含一个小写字母。',
  "err.pattern.^[A-Z' -]*$": '字段"{fieldName}"只能包含大写字母、撇号、空格和连字符。',
  'err.pattern.^[0-9-]{6,15}$': '字段"{fieldName}"必须包含6到15个字符（仅限数字和连字符）。',
  'err.pattern.^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$': '字段"{fieldName}"必须是一个有效的电子邮件地址。',
  'err.pattern.^(?:data:image/(jpeg|png|webp);base64,|data:application/pdf;base64,)*([A-Za-z0-9+/==]+)$': '字段"{fieldName}"必须是有效格式的Base64编码的JPEG、PNG、WebP图像或PDF文件。',
  'err.pattern.^[A-Z]{3}$': '字段"{fieldName}"必须正好包含三个大写字母。',
  'err.pattern.^[\\+]?[(]?[0-9]{3}[)]?[-\\s\\.]?[0-9]{3}[-\\s\\.]?[0-9]{4,9}$': '字段"{fieldName}"必须是有效的电话号码，可以包含区号，允许使用空格、连字符或点。',
  'err.pattern.^(?:\\+[1-9]\\d{6,14}|0\\d{6,14})$': '字段"{fieldName}"必须是有效的国际或国内电话号码（例如：+1234567890或0123456789）。',
  'err.pattern.^[A-Za-z\\s\\-]+$': '字段"{fieldName}"只能包含字母、空格和连字符。',
  "err.pattern.^[a-zA-Z' -]*$": '字段"{fieldName}"只能包含字母、撇号、空格和连字符。',
  'err.pattern.^[A-Za-z0-9\\s\\-]+$': '字段"{fieldName}"只能包含字母、数字、空格和连字符。',
  'err.pattern.^[0-9]*$': '字段"{fieldName}"必须只包含数字。',
  'err.pattern.^[0-9]{4}-[0-9]{2}-[0-9]{2}$': '字段"{fieldName}"必须是一个有效的日期。',
  'err.pattern.^[A-ZÀÁÂÃÄÅÇÈÉÊËÌÍÎÏÒÓÔÕÖÙÚÛÜÆŒ][a-zA-ZÀÁÂÃÄÅÇÈÉÊËÌÍÎÏÒÓÔÕÖÙÚÛÜÆŒ\\-. ]*$': '字段"{fieldName}"必须以大写字母开头，并且可以包含小写字母、重音符号、空格、撇号、连字符或句点。',
  'err.pattern.^[A-Za-zÀÁÂÃÄÅÇÈÉÊËÌÍÎÏÒÓÔÕÖÙÚÛÜÆŒàáâãäåçèéêëìíîïòóôõöùúûüæœ\\-. ]*$': '字段"{fieldName}"必须只包含字母（带或不带重音符号）、空格、撇号、连字符或句点。',
  'err.pattern.^[A-Z0-9]+$': '字段"{fieldName}"必须只包含大写字母和数字。',
  'err.pattern.^(?:\\+[1-9]\\d{0,3})$': '字段"{fieldName}"必须以"+"开头，后跟1到4个数字（第一个数字不能是0）。',
  'err.required': '字段"{fieldName}"是必填项。',
  'err.maxlength.errorValue': '字段"{fieldName}"最多包含{errorValue}个字符。',
  'err.minlength.errorValue': '字段"{fieldName}"最少包含{errorValue}个字符。',
  'err.maxlength': '字段"{fieldName}"太长。',
  'err.minlength': '字段"{fieldName}"太短。',
  'err.pattern': '字段"{fieldName}"格式无效。',
  'err.email': '字段"{fieldName}"必须是一个有效的电子邮件地址。',
  'form.lang.EN': 'English',
  'form.lang.FR': 'Français',
  'form.lang.AR': 'عربي',
  'form.lang.PT': 'Português',
  'form.lang.DE': 'Deutsch',
  'form.lang.RU': 'Русский',
  'form.lang.CN': '中文',
  'successPayment.booking.title': '预约已确认！',
  'global.bookTimeSlot': '预约时间',
  'client.extended.maxMonthlyPaymentsReached': '您已达到每月最大支付次数。请联系支持。',
  'calendar.weekday.sunday': '日',
  'calendar.weekday.monday': '一',
  'calendar.weekday.tuesday': '二',
  'calendar.weekday.wednesday': '三',
  'calendar.weekday.thursday': '四',
  'calendar.weekday.friday': '五',
  'calendar.weekday.saturday': '六',
  'calendar.month.january': '一月',
  'calendar.month.february': '二月',
  'calendar.month.march': '三月',
  'calendar.month.april': '四月',
  'calendar.month.may': '五月',
  'calendar.month.june': '六月',
  'calendar.month.july': '七月',
  'calendar.month.august': '八月',
  'calendar.month.september': '九月',
  'calendar.month.october': '十月',
  'calendar.month.november': '十一月',
  'calendar.month.december': '十二月',
  'calendar.timeline.no_slots': '这一天没有可用的时间段',
  'calendar.timeline.available': '可预约',
  'calendar.timeline.spots_available': '个名额可用',
  'calendar.timeline.fully_booked': '已满',
  'calendar.confirm_booking_title': '确认预约',
  'calendar.confirm_booking_message': '请确认您要预约此时间段。',
  'calendar.booking_in_progress': '预约进行中...',
  'calendar.please_wait': '请等待我们处理您的预约。',
  'calendar.booking_error_title': '预约错误',
  'calendar.booking_success_title': '预约已确认！',
  'calendar.booking_success_message': '您的时间段已成功预约。',
  'calendar.proceed_to_payment': '继续付款',
  'calendar.auto_proceed_message': '自动重定向于...',
  'calendar.date': '日期',
  'calendar.time': '时间',
  'calendar.place': '地点',
  'calendar.loading_month': '正在加载可用性...',
  'extension.error.maxDays': '每次延期不能超过30天。',
  'DYN.processed.NOTICES_ACCEPTED': '通知已确认',
  'notices_validated': '已确认通知',
  'err.daysUntilReport.pattern': '报告间隔必须大于或等于0',
  'err.reportInterval.pattern': '报告间隔必须大于或等于0',
  'err.CompanionsSize.min': '同行人数必须至少为1',
  'err.CompanionsSize.max': '同行人数太长',
  'global.error': '发生错误。请重试。如果问题持续存在，请联系支持。',
  'err.DurationOfStay.required': '停留时间必填',
  'err.DurationOfStay.min': '停留时间必须至少为1天',
  'err.DurationOfStay.max': '停留时间太长',
  'DurationOfStay': '停留时间（天）',
  'tooltip.acceptNotices': '确认当前通知',
  'notices': '通知',
  'ask.notices': '您要确认该通知吗?',
  'accept.notices': '确认通知',
  'err.ModeOfTravel.required': '旅行方式是必填项',
  'err.FlightNumber.required': '航班号是必填项',
  'err.ShipNumber.required': '船号是必填项',
  'err.CarNumber.required': '车牌号是必填项',
  'err.BusNumber.required': '公交号是必填项',
  'err.TrainNumber.required': '火车号是必填项',
  'err.FlightNumber.pattern': '航班号必须有正确的格式',
  'err.ShipNumber.pattern': '船号必须有正确的格式',
  'err.CarNumber.pattern': '车牌号必须有正确的格式',
  'err.BusNumber.pattern': '公交号必须有正确的格式',
  'err.TrainNumber.pattern': '火车号必须有正确的格式',
  'ModeOfTravel': '旅行方式',
  'FlightNumber': '航班号',
  'ShipNumber': '船号',
  'CarNumber': '车牌号',
  'BusNumber': '公交号',
  'TrainNumber': '火车号',
  'DYN.flight': '飞机',
  'DYN.ship': '船',
  'DYN.car': '车',
  'DYN.bus': '公交',
  'DYN.train': '火车',
  'DYN.foot': '步行',
  'expiredSinceTime': '申请已过期 <b>{days} 天 {hours} 小时</b>。',
  'smartTable.filter.sinceDays': '由于',
  'smartTable.filter.createAtEnd': '结束日期',
  'smartTable.filter.createAtStart': '"开始日期',
  'smartTable.filter.timeslotStart': '时间段(开始)',
  'smartTable.filter.timeslotEnd': '时间段(结束)',
  'smartTable.filter.paymentExtStatus': '延期状态',
  'smartTable.filter.paymentStatus': '申请状态',
  'smartTable.filter.overstay': '逾期停留',
  'smartTable.filter.isUrgent': '紧急的',
  'smartTable.filter.applicationType': '申请类型',
  'smartTable.operationId': '文件类型',
  'smartTable.usageUntil': '有效期至',
  'smartTable.usageAfter': '自...起生效',
  'smartTable.price': '价格',
  'smartTable.paymentStatus': '付款状态',
  'smartTable.isUrgent': '紧急的',
  'smartTable.passportNumber': '护照号码',
  'smartTable.fullName': '全名',
  'smartTable.lastName': '姓氏',
  'smartTable.firstName': '名字',
  'smartTable.batchId': '应用参考',
  'smartTable.nationality': '国籍',
  'smartTable.internalReference': '总部参考',
  'smartTable.lock': '锁',
  'smartTable.applicationId': '申请编号',
  'smartTable.creationDate': '创建日期',
  'smartTable.email': '电子邮件',
  'smartTable.role': '角色',
  'smartTable.name': '姓名',
  'smartTable.userId': '用户ID',
  'smartTable.id': '身份证',
  'smartTable.placeId': '位置ID',
  'total': '总计',
  'onlyFinalReview': '此申请正在等待最终审核。',
  'tooltip.consumeOfficer.OUT': '记录人员离开信息的工作人员。',
  'tooltip.consumeOfficer.IN': '为人员办理入场登记的工作人员。',
  'DYN.document.OTHER': '文件',
  'DYN.document.IR': '居留许可',
  'DYN.document.D': '驾驶员',
  'DYN.document.ID': '身份证',
  'DYN.document.P': '护照',
  'scanned': '已扫描',
  'DYN.form.documentNumber.scanned': '{document} 号码',
  'ask.isExtension.confirm': '您确认付款已经完成吗？如果确认，请输入付款参考号、付款方式和所使用的货币。',
  'payment_status.desc.DYN.8.review': '此申请目前正在等待主管审核。',
  'payment_status.DYN.8.review': '等待审核',
  'DYN.role.5': '亭子',
  'DYN.role.4': '合作伙伴名录',
  'DYN.role.3': '管理员',
  'DYN.role.2': 'Orbis 消费者',
  'DYN.role.1': '员工',
  'DYN.role.0': '客户',
  'DYN.role.6': '外部监控者',
  'info.readingPayment': '正在从服务器读取详细信息...',
  'info.searchingPayment': '在服务器中搜索应用程序...',
  'info.convertingImage': '正在将从文档中读取的图像进行转换...',
  'info.disconnect': '正在断开连接...',
  'info.readingDG': '正在读取数据组...',
  'info.doingPA': '执行被动认证...',
  'info.readingCertificate': '正在读取签名证书...',
  'info.testingBAC': '正在执行基本访问控制...',
  'info.connecting': '正在连接芯片...',
  'info.readingMrz': '正在读取MRZ...',
  'info.testingReaderCard': '正在检查读卡器中是否有智能卡...',
  'info.testingReader': '检查读者是否存在...',
  'tooltip.prepareLandingVisa': '准备落地签',
  'printEventsCollapse': '此应用程序的所有打印事件',
  'tooltip.printEvents': '此应用程序所有打印事件的列表',
  'approval.daysGranted.DYN.': '批准的天数',
  'ask.closeApplication': '当旅行者能够提供证明，表明某项操作已离线完成时，可以使用此操作。这将使该记录被视为已解决并被丢弃。请确认您是否希望关闭此请求。此操作为最终操作，无法撤销。',
  'done.closeApplication': '该申请已成功关闭。您是否想基于此申请创建一个新的申请？',
  'documents.load': '加载所有文档',
  'documents.add': '添加缺少的文档',
  'print.extension': '打印扩展',
  'open.visaReference': '打开关联的应用程序',
  'error.updatePassport': '更新应用程序时发生错误。请重试。',
  'supervision.catC.ordinary.refuse': '拒绝进入',
  'supervision.catC.ordinary.entry': '入住',
  'ExistingValidEntryReference': '现有有效入境参考',
  'existingValidEntryReference.desc': '此申请包含一个<b>有效的入境参考号</b>。这意味着旅客已经支付费用并获得了入境许可。在继续操作之前，请确保检查该参考号的有效性。如果一切正确，您可以继续办理入住手续。',
  'no.must_pay': '仍需付款',
  'continue': '继续',
  'global.changePassword': '更改密码',
  'signIn.forgotPassword': '忘记密码',
  'signIn.title': '登录',
  'global.notAccount': '还没有账户？',
  'global.continue': '继续',
  'Occupation': '职业',
  'signUp.title': '创建账户',
  'DYN.selectedPaymentMethod.VISA': '您已选择使用 <b>Visa</b> 付款。',
  'DYN.selectedPaymentMethod.MASTERCARD': '您已选择使用 <b>Mastercard</b> 付款。',
  'DYN.selectedPaymentMethod.AMERICAN_EXPRESS': '您已选择使用 <b>American Express</b> 付款。',
  'DYN.selectedPaymentMethod.DINERS_CLUB': '您已选择使用 <b>Diner\'s Club</b> 付款。',
  'DYN.selectedPaymentMethod.UNION_PAY': '您已选择使用 <b>Union Pay</b> 付款。',
  'DYN.selectedPaymentMethod.ZIMSWITCH': '您已选择使用 <b>Zimswitch</b> 付款。',
  'DYN.selectedPaymentMethod.PAYPAL': '您已选择使用 <b>PayPal</b> 付款。',
  'DYN.selectedPaymentMethod.DISCOVER': '您已选择使用 <b>Discover</b> 付款。',
  'ProvisionnalEntryPort': '期望的登记点',
  'payment_status.desc.offlineApplication': '此应用程序目前正在<b>离线</b>处理。处理完成后，将继续进行并将发送到同步队列。',
  'warn.payment.offlineApplication.quit': '您即将离开离线申请流程。确定要继续吗？<br><br><b>所有数据将会丢失。</b>',
  'consumeMode.transit': '您当前处于<b>中转模式</b>，申请将<b>同时进行入境和出境处理</b>。此模式适用于不需要在该国停留的中转旅客。',
  'no_apply.overstay': '无费用',
  'apply.overstay': '申请费',
  'paymentExtension.overstay': '此申请目前处于超期逗留状态。<br><br><strong>延期基础价格：</strong> {basePrice}<br><strong>超期罚款：</strong> {penalty}<br><strong>含罚款总计：</strong> {totalPrice}<br><br>您可以选择是否适用超期费用。',
  'clear.storage.tooltip': '清除应用程序本地存储的所有数据',
  'clear.storage': '清空存储',
  'ask.clear.storage': '<b>此操作将执行完整的站点数据清理，类似于 Chrome 的"清除站点数据"功能。</b><br>这将清除：localStorage、sessionStorage、IndexedDB、Cache Storage、Service Workers、Cookies 和其他浏览器存储。队列中尚未处理的数据将在清除前被下载到一个 JSON 文件中。<br><br>您确定要继续吗？',
  'download.logs.tooltip': '下载在线和离线异常活动的完整日志。该文件将以 JSON 格式下载，主要用于调试目的。',
  'download.logs': '下载日志',
  'scan.noExitFound.wrongPassportType': '已为该人员找到一个或多个“准备离境”状态，但护照类型与扫描的证件不匹配。<br><b>请为该人员创建新的离境记录。</b>',
  'scan.noEntryFound.wrongPassportType': '已为该人员找到一个或多个“准备登记”状态，但护照类型与扫描的证件不匹配。<br><b>请为该人员创建新的入境记录。</b>',
  'customerName': '客户名称',
  'printEvent.desc': '该申请及其所有文件已由用户于 {date} 打印',
  'time.year': '{value} 年',
  'time.months': '{value} 个月',
  'time.month': '{value} 个月',
  'time.weeks': '{value} 周',
  'time.week': '{value} 周',
  'time.days': '{value} 天',
  'time.day': '{value} 天',
  'print.alreadyPrinted': '此申请的文件最后一次由用户 {user} 于 {date} 打印。您是否要再次打印？',
  'approval.daysGranted.limit': '批准的天数不得超过申请的{天数}天。',
  'paymentUntil.gracePeriod': '以下申请目前处于宽限期，宽限期将于 <b>{date}</b> 结束。<br><br>您可以选择是否收取滞留费用。',
  'payment.consume.placeNotAllowed': '此申请无法在本地点处理。旅客必须前往以下地点之一： <br><b>{places}</b>',
  'tooltip.externalIndexedData': '此人有多本护照。',
  'visaDocumentsMaxTotalSize': '上传文档的总大小超过了允许的最大大小{size}MB。请减小文档大小并重试。',
  'global.connection.timeout': '连接中断。请检查您的互联网连接，然后重试。',
  'help': '帮助',
  'unlimited': '无限',
  'application.placeAllowed': '<b>地点限制：</b> 此文件只能在以下地点处理：<b>{places}</b>',
  'transactionReference.alt': '交易参考',
  'paymentType.alt': '支付类型',
  'changeGender.ask': '申请中的性别必须更改为男性或女性。',
  'print.askMultiple': '您想在打印输出中包含所有相关文件吗？',
  'application.id': '申请编号',
  'printSticker': '打印签证贴纸',
  'correctionFields': '以下字段已更正：',
  'corrected.desc': '此申请已由申请人在 {date} 更正。',
  'recentlyCorrected': '已更正',
  'visaValidFrom': '入境有效期从',
  'visaValidUntil': '入境有效期至',
  'online': '在线',
  'offline': '离线',
  'issuingOfficer.alt': '签发官员',
  'placeOfIssue': '签发地点',
  'tooltip.hasBeenCorrected': '此申请已由申请人更正。',
  'tooltip.delayed': '此请求已延迟。',
  'movement.tooltip': '查看申请的移动详情。',
  'tooltip.extendStay': '延长申请人的停留时间',
  'decisionLetter.title': '官方签证决定函',
  'decisionLetter.approval.title': '签证申请已获批准',
  'decisionLetter.refusal.title': '签证申请已被拒绝',
  'decisionLetter.applicationId': '申请编号',
  'decisionLetter.approvalDate': '批准日期',
  'decisionLetter.refusalDate': '拒签日期',
  'decisionLetter.dear': '尊敬的',
  'decisionLetter.applicant': '申请人',
  'decisionLetter.documentType.application': '签证申请',
  'decisionLetter.documentType.extension': '延长逗留',
  'decisionLetter.approval.body1': '您的签证申请已获批准。',
  'decisionLetter.approval.body2': '请在抵达入境口岸（PoE）时出示随附的二维码。',
  'decisionLetter.refusal.body1': '您的签证申请未获批准。',
  'decisionLetter.refusal.body2': '如有需要，您可以重新提交申请，并确保纠正任何可能导致此次拒签的问题。',
  'decisionLetter.signature': '谨代表移民总局局长。',
  'printApprovalLetter': '打印批准信',
  'operation.REFUSEOUT': '拒绝出境',
  'operation.REFUSEIN': '拒绝入境',
  'error.closeApplication': '关闭申请时发生错误。请再试一次。',
  'closeApplication': '标记为已关闭',
  'tooltip.closeApplication': '将申请标记为已关闭。此操作不可撤销。',
  'transfert.viewOutOfState.desc': '您正在查看申请的状态。请注意，您<b>警告</b>：此应用可能处于不正确的状态。请仔细核对客户提供的文件，以确保该应用的准确状态。由于您处于<b>{consumeMode}模式</b>，您可以选择<b>强制以{transfertMode}方式处理</b>，即使当前状态通常不允许，也可以在您认为有必要时执行。',
  'understand': '我理解',
  'request.viewOutOfState.button': '强制 "{consumeMode}"',
  'ExtraDocument1': '额外文件 #1',
  'ExtraDocument2': '额外文件 #2',
  'ExtraDocument3': '额外文件 #3',
  'ExtraDocument4': '额外文件 #4',
  'ExtraDocument5': '额外文件 #5',
  'paperSize': '纸张宽度',
  'change_lang': '更改语言',
  'queue.export.desc': '是否要将当前队列导出为 JSON 文件？<b>导出后，本地队列将被删除</b>。您确定要继续吗？',
  'queue.export': '导出为 JSON',
  'queue.import': '从 JSON 导入队列',
  'nationality': '国籍',
  'gender': '性别',
  'HQReference': '总部参考',
  'global.resetDefaults': '恢复默认设置',
  'shortcuts.desc': '您可以在下方设置自己的键盘快捷键。点击您想设置新快捷键的键，并按下键盘上的所需键。',
  'press.key': '按下任意键设置快捷键...',
  'dashboard.keyboardShortcuts': '键盘快捷键',
  'tooltip.changeShortcuts': '更改键盘快捷键',
  'global.changeShortcuts': '更改快捷键',
  'retake_picture': '重新拍照',
  'picture': '照片',
  'error.faceCheck': '处理人脸匹配时发生错误。请再试一次。',
  'faceCheck.see_score': '人脸匹配',
  'recommendOrNot': '推荐与否',
  'recommended': '推荐',
  'not_recommended': '不推荐',
  'error.downgrade': '降级请求时发生错误。请再试一次。',
  'done.downgrade': '请求已成功降级。',
  'request.downgrade': '降级',
  'request.extendStay': '延长停留时间',
  'ResidencePermitNumber': '居住许可编号',
  'error.payment.noInternalReference': '此申请需要总部参考才能进行审核。请等待提供参考。',
  'request.revision': '是否要激活自动跳过功能？此功能将自动跳过不需要您输入的已审核步骤。',
  'notice.BORDER_PASS': '边境通行证',
  'form.borderPassNumber': '边境通行证编号',
  'form.dateOfBirth': '出生日期',
  'form.issueDate': '签发日期',
  'form.authorizedCrossingPoints': '授权过境点',
  'form.issuedBy': '签发人',
  'form.externalCode': '外部代码 (ICAO)',
  'err.invoke': '错误',
  'ask.pendingRequest': '您有一个待更正的请求。现在是否打开？',
  'entry.confirmation': '您确定提供的所有信息正确吗？点击“确认”后，您将提交申请。',
  'free': '免费',
  'last_update': '最后更新',
  'count': '计数',
  'tooltip.linkedExtensions': '这是停留延期。点击查看详细信息。',
  'extension': '延期',
  'client.extended.badPaymentMetadata': '支付元数据无效。请重试，或如果问题持续，请联系支持。',
  'DaysRequested': '请求的天数',
  'extensions.desc': '待审核的停留延期',
  'extend': '延长',
  'CheckboxVisaExtendFees': '我确认提供的信息真实准确，并且我同意停留延期费用、条款和隐私政策。',
  'AttestantDocument': '担保人文件',
  'AffidavitCustody': '监护宣誓书',
  'CopyOfEntry': '入境副本',
  'DepartureTicket': '出境机票',
  'DYN.Self': '本人',
  'DYN.Spouse/Dependent': '配偶/家属',
  'DYN.Employee/Employer': '雇员/雇主',
  'DYN.Co-Director': '联合董事',
  'DYN.Lawyer': '律师',
  'VisaReference': '签证参考',
  'ReasonForExtension': '延期原因',
  'AttestantID': '担保人 ID',
  'AttestantName': '担保人姓名',
  'AttestantPhone': '担保人电话',
  'AttestantEmail': '担保人电子邮件',
  'AttestantAddress': '担保人地址',
  'AttestantRelation': '与担保人的关系',
  'start_extend': '延长停留时间',
  'visaExtend.title': '停留延期',
  'days': '天',
  'day': '天',
  'err.Email.email': '电子邮件格式不正确',
  'err.EmergencyEmail.email': '紧急联系人电子邮件格式不正确',
  'kiosk.standby.text1': '通过这台平板电脑或在线，几次点击即可开始填写您的声明。',
  'kiosk.standbyDesc.text1': '在您开始之前，请注意以下信息：',
  'kiosk.standbyDesc.li1': '您将填写一份收集您的个人数据和旅行详细信息的电子表格。',
  'kiosk.standbyDesc.li2': '所提供的所有信息必须准确无误，并与您的旅行证件（护照、签证等）相符。',
  'kiosk.standbyDesc.li3': '完成表格后，您可以直接携带身份证件前往移民柜台。',
  'kiosk.standbyDesc.li5': '如果您遇到任何困难，请随时向边境站的工作人员寻求帮助。',
  'kiosk.standbyDesc.text2': '准备好填写入境声明时，点击“开始”。',
  'kiosk.success.title': '申请提交成功',
  'kiosk.success.text1': '现在您可以携带旅行证件前往移民柜台。官员将进行最终检查并确认您的入境。',
  'kiosk.success.text2': '如果您有任何问题或困难，请随时向可用的工作人员寻求帮助。',
  'confirm.revision': '确认修订',
  'print.isDone': '通知是否已成功打印？请确保将打印的通知提供给申请人。',
  'form.hostPhone': '房东电话',
  'transit': '过境',
  'conditionalEntry': '有条件入境',
  'departure': '离境',
  'form.paragraph': '段落',
  'form.dateOfRefusal': '拒绝日期',
  'form.purpose': '访问目的',
  'form.host': '房东',
  'form.officer': '官员',
  'form.reportAt': '报告地点',
  'form.reportOn': '报告日期',
  'form.reportInterval': '报告间隔',
  'notice.desc.RESTRICTION': '临时限制通知告知申请人完成流程所需的文件。您可以选择申请人必须在指定期限内提供的缺失文件。',
  'notice.REFUSAL': '入境拒绝通知',
  'notice.desc.REFUSAL': '申请人被拒绝入境。',
  'notice.desc.REPORTING': '访客通知允许申请人入境，但可能需要进一步报告。您可以选择申请人必须在指定期限内提供的缺失文件。',
  'form.stationReference': '站点参考',
  'form.fullNames': '全名',
  'form.reportLocation': '报告地点',
  'form.daysUntilReport': '报告截止天数',
  'form.otherMissingDocument': '其他缺失文件',
  'form.residentialAddress': '居住地址',
  'form.businessAddress': '业务地址',
  'form.hqReference': '总部参考',
  'residentPermit': '居住许可',
  'notice.title': '可打印的通知',
  'notice.desc': '请从下方列表中选择一项通知。填写所需字段后，您可以为申请人打印通知。',
  'notice.RESTRICTION': '临时限制通知',
  'notice.REPORTING': '访客通知',
  'notice.RESTRICTION.desc': '申请人必须在指定期限内提供缺失文件。',
  'notice.REFUSAL.desc': '申请人被拒绝入境。',
  'notice.REPORTING.desc': '申请人允许入境，但可能需要进一步报告。',
  'passportType.kioskWarning': '所选国籍属于 C 类政权。请立即前往移民官员处。',
  'free.charge.total': '总费用免费',
  'err.entryPoints': '加载计划入境口岸时出错',
  'summary.your_meta': '您的数据（点击展开）',
  'summary.payOnline': '我更愿意现在在线支付，而不是在抵达时在官员柜台支付。',
  'summary.payOnline.desc': '选择以下选项将带您进入支付页面。如果您选择不在线支付，您将在抵达时在官员柜台支付签证费用。',
  'summary.meta': '的数据（点击展开）',
  'EmergencyLastName': '紧急联系人姓氏',
  'EmergencyFirstName': '紧急联系人名字',
  'EmergencyEmail': '紧急联系人电子邮件',
  'EmergencyPhone': '紧急联系人电话',
  'person.name': '选定人员的姓名',
  'DYN.identity-card': '身份证',
  'DYN.resident-permit': '临时居留许可',
  'DYN.identity-card.desc': '身份证是政府签发的用于国内身份识别的文件。',
  'DYN.resident-permit.desc': '临时居留许可是政府为外籍人员签发的官方文件，允许其在指定时间内居住在该国。',
  'NonOrdinaryPassMission': '官方访问的原因',
  'PreviousConvictionsHomeAsk': '您或您的家属是否在本国有任何犯罪记录？',
  'PlaceOfBirthCountry': '出生国家',
  'PlaceOfBirthCity': '出生城市',
  'OtherName': '其他名字',
  'travelName': '申请参考',
  'plannedEntry': '计划入境口岸',
  'summary.title': '摘要',
  'urgent': '紧急',
  'visaType': '文件类型',
  'passportType': '身份证明类型',
  'passportType.acknowledge': '选择此护照类型，即表示您承认不遵守使用条件可能导致入境被拒绝。',
  'passportType.selectRefugeeNationality': '为难民护照选择国籍 <br>',
  'form.travelName.already': '<b>此申请已提交，并带有以下申请参考。如果您想更改参考，请重新开始新申请。</b>',
  'application.current_person': '您正在为...编辑申请',
  'DYN.USD': '美元',
  'DYN.EUR': '欧元',
  'DYN.ZWL': '津巴布韦元',
  'DYN.GBP': '英镑',
  'DYN.BWP': '博茨瓦纳普拉',
  'DYN.KMF': '科摩罗法郎',
  'participants.edit': '编辑申请人',
  'request.existSaved': '已找到保存的申请，您想加载其数据吗？（如果您点击“否”，该申请将被删除，您将重新开始一个新的申请）',
  'participant.hasData': '您已经为此参与者输入了数据。如果继续，数据将会丢失。您确定要继续吗？',
  'participant.selectAtLeastOne': '请至少选择一名参与者才能继续。',
  'participants.title': '申请人',
  'participants.desc': '请选择您自己和/或将成为此申请一部分的人员。</br><b>最后的支付将为所有选择的人进行。</b></br></br>您可以随时通过点击表单上方显示的姓名，添加/删除人员或编辑其申请。</br></br>{participantText}',
  'participant.ready': '准备好时，点击“继续”。',
  'participant.missing': '继续之前，请创建至少一个人。',
  'travelName.title': '申请参考',
  'form.travelName': '申请参考',
  'form.travelName.desc': '申请参考将用于更轻松地识别您的申请。',
  'nationality.title': '国籍',
  'nationality.desc': '请选择您所使用护照上的国家。',
  'passportType.title': '文件类型',
  'passportType.desc': '请选择您用于此申请的旅行证件类型。',
  'visaType.title': '签证类型',
  'visaType.desc': '请选择您希望申请的签证类型。此列表会根据您的国籍和护照类型而有所不同。',
  'urgent.title': '普通/加急签证',
  'urgent.desc': '如果此申请为<b>紧急</b>，请选择此选项。处理时间将缩短，但将收取<b>额外费用</b>来提供此服务。</br></br>',
  'priority.normal': '正常',
  'priority.urgent': '紧急',
  'priority.normal.DYN.desc': '在七 (7) 个工作日内处理。',
  'priority.urgent.DYN.desc': '在三 (3) 个工作日内处理。',
  'visa.paidOnArrival.title': '抵达时支付签证费用',
  'visa.paidOnArrival.desc': '允许符合条件的旅行者在目的地的入境口岸获得签证，简化了短期访问的入境流程。',
  'visa.paidOnline.title': '在线支付签证费用',
  'visa.paidOnline.desc': '允许在指定的一（1）个月期间内一次或多次入境该国，之后的入境需要重新签发签证。',
  'PassportType': '护照类型',
  'PassportCountry': '护照签发国家',
  'form.passportCountry': '护照签发国家',
  'DYN.ordinary': '普通护照',
  'DYN.diplomatic': '外交护照',
  'DYN.official': '公务护照',
  'DYN.service': '服务护照',
  'supervision.nofee': '需要主管验证以进行无罚款请求。',
  'NoFeeProof': '无费用证明',
  'webcam.nofeeProof.confirm': '请拍摄无费用证明文件（No Fee Proof）的照片。',
  'open.register': '打开注册',
  'DYN.refugee': '难民护照或旅行证件',
  'DYN.ordinary.desc': '普通护照是为公民签发的最常见类型的护照，适用于一般旅行。',
  'DYN.diplomatic.desc': '外交护照是为外交官和领事签发的，用于公务旅行和在国外的居住。',
  'DYN.refugee.desc': '难民护照是由国家签发给被认定为难民的人，用于出国旅行。',
  'DYN.official.desc': '公务护照是为政府工作人员签发的，用于公务旅行和在国外的居住。',
  'DYN.service.desc': '服务护照是为政府工作人员签发的，用于公务旅行和在国外的居住。',
  'DYN.marine': '海员护照',
  'DYN.marine.desc': '海员护照是为水手和船员签发的，用于旅行和在国外的居住。',
  'DYN.laissez-passer': '通行证',
  'DYN.laissez-passer.desc': '通行证是由联合国或其机构签发的，用于公务旅行和在国外的居住。',
  'Urgent': '这是一个紧急请求。我理解处理时间将会缩短，但费用将会更高。',
  'photo.passport.scanned': '护照已扫描',
  'review.nr.final': '最终审核',
  'review.nr': '审核编号',
  'err.ArrivalDate.maxDateMilliTo': '护照的到期日必须在您到达该国日期的至少六（6）个月之后。请在申请签证前更新此护照。',
  'err.DateOfExpiry.maxDateMilliTo': '您的护照将在到达该国的六（6）个月内到期。请在申请签证前更新此护照。',
  'place.update.error': '更新地点时发生错误',
  'dashboard.kiosk.start': '开始流程',
  'form.role.kiosk': '自助服务终端',
  'FundsAvailable': '金额',
  'FundsAvailableCurrency': '货币',
  'emergency_contact_text': '请提供紧急情况下可以联系的人员的联系方式。',
  'emergency_contact': '紧急联系人 / 近亲',
  'err.BirthDay.mustBeEqualOrBefore': '出生日期必须等于或早于护照签发日期',
  'err.DateOfIssue.mustBeEqualOrAfter': '签发日期必须等于或晚于出生日期',
  'internet.lost': '互联网连接丢失。</br>请检查您的连接。',
  'err.DateOfExpiry.maxDateMilliFromToday': '您的护照将在今天起的六（6）个月内到期。请在申请签证前更新此护照。',
  'err.DepartureDate.maxDateMilliFrom': '离境日期与到达日期之间的时间过长。请参阅签证的时间限制。',
  'requirements': '要求',
  'err.file.size': '文件大小太大。最大尺寸为：',
  'revision.success': '您的请求更新已成功提交。批准后，您将收到包含二维码的电子邮件。',
  'revision.free': '免费修订',
  'revision.start': '我们已尽力根据您在初始申请中提供的信息填写了字段，除引起问题的字段外。请检查信息并进行更正。您想继续吗？',
  'file_uploaded': '文件已上传并存储',
  'refusal.desc2': '以下字段存在问题：',
  'start_correction': '开始更正',
  'payment.selectMode': '请选择有问题的字段。您可以选择多个字段。',
  'suspendReason.desc': '请简要描述修订请求的原因。此描述将与所选的问题字段一起发送给请求者。',
  'err.ArrivalDate.mustBeEqualOrBefore': '到达日期必须等于或早于离境日期',
  'err.DepartureDate.mustBeEqualOrAfter': '离境日期必须等于或晚于到达日期',
  'qr.request_desc': '此二维码作为签证处理的数字通行证。政府保留在签证管制时批准或拒绝入境的权利。',
  'request_state.PENDING': '待定',
  'document.Screening': '筛查',
  'err.SpouseBirthDay.max': '配偶的出生日期无效',
  'err.ArrivalDate.min': '到达日期无效',
  'smartTable.timeslotPlaceId': '地点',
  'err.DepartureDate.min': '离境日期无效',
  'err.DateOfIssue.max': '签发日期无效',
  'err.BirthDay.max': '出生日期无效',
  'err.dependants_date_of_birth.max': '家属的出生日期无效',
  'err.DateOfExpiry.min': '到期日期无效',
  'dependants': '家属',
  'male': '男性',
  'female': '女性',
  'other': '其他',
  'single': '单身',
  'married': '已婚',
  'separated': '分居',
  'divorced': '离婚',
  'widowed': '丧偶',
  'select_reason_first': '请在上一页选择访问原因以查看所需文件列表。',
  'visaIntro.title': '申请',
  'remove': '移除',
  'dependant_add': '添加家属',
  'dependant': '家属',
  'upload_file': '上传文件（< {size}）',
  'PassportPhoto': '最近的照片',
  'PassportScan': '护照个人信息页',
  'EventInvitationLetter': '活动邀请函',
  'ProofOfResidenceHost': '主人的住所/预订证明（已签名）',
  'AddressAtDestination': '目的地地址',
  'HostInvitationLetter': '房东邀请函',
  'ProofOfResidence': '居住证明',
  'ApplicationLetter': '申请函',
  'ResidentialStatusOfHost': '房东的居住状态',
  'ReasonOfVisitProof': '访问目的证明',
  'BusinessLetter': '商务信函/个人信函',
  'BusinessProfile': '商业简介',
  'InvitationLetterAndBusinessProfile': '邀请函和主办公司文件（已签名）',
  'InvitationLetter': '邀请函',
  'LetterOfAcceptanceFromSchool': '确认信',
  'DYN.male': '男性',
  'DYN.female': '女性',
  'DYN.other': '其他',
  'DYN.single': '单身',
  'DYN.married': '已婚',
  'DYN.separated': '分居',
  'DYN.divorced': '离婚',
  'DYN.widowed': '丧偶',
  'DYN.married_according_to_custom': '根据习俗已婚',
  'DYN.religiously_married': '根据宗教习俗已婚',
  'passport.valid': '扫描的文件似乎没有被篡改或吊销，并由签发国签署。',
  'travel_information_title': '注意',
  'visaPrice.desc': '在申请结束时，您需要使用 Visa 或 MasterCard 进行支付。此支付不可退还。',
  'visaPrice': '签证价格',
  'required': '必填',
  'DYN.holiday_visa': '度假签证',
  'DYN.live_here': '长期居住',
  'DYN.business_visa': '商务签证',
  'DYN.conferencing_visa': '会议签证',
  'DYN.transit_visa': '过境签证',
  'DYN.student_visa': '学习签证',
  'DYN.sports_visa': '体育',
  'DYN.arts_visa': '艺术',
  'DYN.other_visa': '其他',
  'DYN.event_visa': '活动',
  'document': '文件',
  'documents_attached': '待附加文件',
  'Dependants': '家属',
  'dependants_name': '姓名',
  'dependants_passport_number': '护照号码',
  'dependants_date_of_birth': '出生日期',
  'dependants_place_of_birth': '出生地点',
  'Spouse': '配偶',
  'SpouseFullName': '配偶姓名',
  'SpousePassportNumber': '配偶护照号码',
  'SpouseBirthDay': '配偶出生日期',
  'SpousePlaceOfBirth': '配偶出生地点',
  'ArrivalDate': '预计到达日期',
  'DepartureDate': '预计离境日期',
  'ReferencePreviousVisa': '上一个签证的参考',
  'PreviousConvictionsHome': '在本国的定罪性质',
  'travel_information': '旅行信息',
  'DateOfIssue': '签发日期',
  'DateOfExpiry': '到期日期',
  'PlaceofIssue': '签发地点',
  'Email': '电子邮件',
  'Phone': '电话号码',
  'HomeAddress': '当前居住地址',
  'HostName': '接待方名称',
  'err.InvitingCompanyName.required': '邀请公司名称为必填项',
  'InvitingCompanyName': '邀请公司名称',
  'form.seniority': '资历等级',
  'LastName': '姓氏',
  'FirstName': '名字',
  'BirthDay': '出生日期（与护照完全一致）',
  'PlaceOfBirth': '出生地',
  'Gender': '性别',
  'MaritalStatus': '婚姻状况',
  'CheckboxVisaFees': '我确认所提供的信息真实准确，并同意签证费用、条款和隐私政策。',
  'PassportNumber': '护照号码',
  'Nationality': '国籍',
  'err.nationality.required': '国籍是必填项。',
  'PurposeOfVisit': '访问目的',
  'VisaType': '签证类型',
  'visitor_details': '申请人详细信息',
  'personal_details': '个人信息',
  'contact_details': '联系方式',
  'miscellaneous_details': '旅行详细信息',
  'form.importantRead': '重要 - 仔细阅读',
  'form.completeInEnglish': '请用英文清楚填写。',
  'form.selectApplicableFields': '请选择下面所有适用的字段。',
  'spouse_details': '配偶信息',
  'payment': '支付',
  'global.scan_qr': '验证二维码',
  'qr.nosuch': '加载中... 系统中尚未找到二维码。请检查互联网连接。',
  'qr.faked': '服务器响应：二维码不存在，可能是伪造的！',
  'qr.quicklook': '关键信息',
  'global.toPayments.DYN.': '查看申请',
  'payment.duplicate.open': '打开新支付？',
  'ONE_DAY': '1天',
  'THREE_DAYS': '3天',
  'ONE_WEEK': '1周',
  'TWO_WEEKS': '2周',
  'ONE_MONTH': '1个月',
  'TWO_MONTHS': '2个月',
  'SIX_MONTHS': '6个月',
  'ONE_YEAR': '1年',
  'place_created.desc': '新地点已创建，现在可用。',
  'payment_status.DYN.NONE': '-- 无筛选 --',
  'dropdown.state': '状态',
  'payment.qrList.title': '二维码支付列表',
  'see.qr_list': '查看二维码列表',
  'form.role.partner_registrer': '合作伙伴注册',
  'form.reason': '原因',
  'global.reject': '拒绝',
  'payment.validate_desc': '您确定要验证此支付吗？',
  'payment.reject_desc': '您确定要拒绝此支付吗？别忘了添加原因',
  'qr.title': '二维码',
  'dashboard': '仪表板',
  'dashboard.people.DYN.': '已保存的人员',
  'dashboard.my_account': '我的账户',
  'form.id': 'ID',
  'payments.scan': '扫描二维码',
  'print.qr.desc': '这是一个唯一且安全的二维码，只能按指定的次数使用。请不要更改它，以保持其可用性。',
  'print.qr.title': '二维码',
  'print.informations': '信息',
  'print.notice.folding': '折叠说明',
  'print.notice.desc2': '如果对本文件有任何疑问，请通过电话或电子邮件联系支持。',
  'print.notice.desc1': '请将本文件远离水或火源。',
  'print.notice.title': '注意',
  'client.extended.openSuchPayment': '此用户已激活一笔付款',
  'form.externalId': '付款参考',
  'form.userExternalId': '外部ID',
  'global.confirm': '确认',
  'global.submit': '提交',
  'global.back': '返回',
  'global.close': '关闭',
  'global.contact_support': '联系支持',
  'global.previous': '上一步',
  'global.next': '下一步',
  'global.accept': '接受',
  'global.support': '支持',
  'global.consume': '消费',
  'global.validate': '验证',
  'global.reset': '重置',
  'global.delete': '删除',
  'global.update': '更新',
  'global.download': '下载',
  'global.print': '打印',
  'global.print_c7': '打印票据',
  'global.checkIn': '入住',
  'choose-lang.title': '语言偏好',
  'choose-lang.desc': '请选择将用于此应用程序的语言。',
  'global.personalNum': '个人编号',
  'global.passportNum': '护照编号',
  'global.add': '添加',
  'global.block': '封锁',
  'global.blocked': '已封锁',
  'global.unblock': '解锁',
  'global.daily_otp': '每日代码',
  'global.refresh': '刷新',
  'global.connect': '连接',
  'global.disconnect': '断开连接',
  'form.email': '电子邮件',
  'form.name': '名称',
  'form.firstName': '名字',
  'form.lastName': '姓氏',
  'form.password': '密码',
  'form.password2': '重新输入密码',
  'form.linkType': '此人与你的关系是什么？',
  'form.userId': '用户ID',
  'form.parentId': '父ID',
  'form.amount': '金额',
  'form.currency': '货币',
  'form.buyingOption': '购买的文件',
  'form.place': '地点',
  'form.role': '角色',
  'form.connectUAPattern': '用户代理模式',
  'form.connectIPRange': 'IP范围',
  'form.state': '状态',
  'form.created_date': '创建日期',
  'form.created_place': '创建地点',
  'form.consumed_place': '已使用地点',
  'form.email_code': '电子邮件中的代码',
  'form.phone': '电话号码',
  'form.worker': '员工ID',
  'form.password_old': '当前密码',
  'form.password_new': '新密码',
  'form.idCard': '身份证号',
  'form.type.CASH': '现金',
  'form.type.CARD': '卡片',
  'form.role.customer': '顾客',
  'form.role.worker': '员工',
  'yes': '是',
  'no': '否',
  'form.borderPass': '发放边境通行证',
  'form.role.orbis_consumer': 'Orbis 消费者',
  'form.role.admin': '管理员',
  'form.perm2.DYN.': '处理申请',
  'form.perm3.DYN.': '审查申请',
  'form.perm4.DYN.': '创建/管理地点、用户和申请',
  'client.extended.clientNotAllowed': '您的账户当前不允许在此地点使用。请检查您的连接设置。',
  'err.submit': '表单提交错误',
  'err.place.required': '地点是必填项',
  'err.noSmsPerm': '未授予SMS权限',
  'err.noSmsReceive': '无法绑定SMS接收',
  'helps.showProceed': '显示继续',
  'helps.showScan': '显示扫描文档',
  'payment_status.DYN.undefined': '当前状态 - 不是操作',
  'client.extended.missingResourceLogin': '无法连接，凭证错误',
  'client.extended.linkedAccountExists': '此电子邮件已存在关联账户',
  'client.extended.attachedPayments': '无法修改此人，已经有创建的申请与其关联。',
  'client.extended.badPayload': '请求信息有误',
  'client.extended.placeNotAllowed': '地点不允许',
  'client.extended.locked': '账户已锁定',
  'client.extended.clientBadOtp': '每日代码错误',
  'client.extended.confirmationRequired': '需要确认',
  'confirmationRequired.email': '确认链接已发送至您的电子邮箱，请查看收件箱并在登录前完成确认。',
  'confirmationRequired.sms': '确认链接已通过短信发送，请查看您的消息并在登录前完成确认。',
  'client.extended.badPaymentConfirmation': '付款无法继续：其中一项检查未通过',
  'time': '时间',
  'place': '地点',
  'home.first': '您的账户已验证，您现在可以登录。',
  'payOnline': '在线支付',
  'login.sign_in': '登录',
  'photo.unavailable': '照片不可用',
  'global.entry': '入境',
  'global.exit': '出境',
  'menu.users': '用户',
  'menu.places': '地点',
  'create_user.title': '创建用户',
  'create_payment.title': '创建支付',
  'create_place.title': '创建地点',
  'users.title': '用户数据库',
  'payments.title': '支付数据库',
  'payments.download_csv': '下载CSV',
  'create_card_payment.title': '在线支付',
  'places.title': '地点列表',
  'forgot_password.title': '重置密码',
  'welcome.title_1.DYN.': '{appName}欢迎您',
  'welcome.text_1.DYN.': '欢迎访问{appName}官方门户。<br>本在线服务让您安全便捷地获取官方证件。',
  'welcome.text_1.1.DYN.': '准备好了解如何操作了吗？让我们开始吧！',
  'welcome.title_2.DYN.': '什么是{appName}？',
  'welcome.text_2.DYN.': '{appName}是一款安全的数字平台，让您可以在线申请官方证件，如身份证、护照、居留证等。',
  'welcome.text_2.1.DYN.': '您可以随时随地申请，并通过电子邮件收到证件，同时附带独一无二的二维码以确保其真实性。',
  'welcome.title_3.DYN.': '作为工作人员',
  'welcome.text_3.DYN.': '通过{appName}，您可以离线管理申请。我们对我们的二维码生成方式的安全性和可靠性充满信心。',
  'welcome.text_3.1.DYN.': '您还可以管理组织的用户和地点。',
  'welcome.text_4.DYN.': '您甚至可以离线管理申请。我们对我们的二维码生成方式的安全性和可靠性充满信心。',
  'welcome.text_4.1.DYN.': '一旦重新联网，所有内容都将自动同步。',
  'welcome.title_5.DYN.': '开始您的申请',
  'welcome.text_5.DYN.': '在接下来的页面中，您只需几步即可在线申请官方证件。<br><br>申请通过后，您会通过电子邮件收到证件，并附有包含所有必要验证信息的安全二维码。',
  'payment_status.DYN.PROPOSED': '待付款',
  'payment_status.DYN.PAID': '准备入住',
  'payment_status.DYN.PAID_NOT_CONFIRMED': '等待审核',
  'payment_status.DYN.USED': '已退房',
  'payment_status.DYN.DUPLICATED': '已复制',
  'payment_status.DYN.REFUNDED': '已退款',
  'payment_status.DYN.EXPIRED': '被拒',
  'payment_status.DYN.PENDING': '等待修正',
  'payment_status.DYN.DELAY_PAY_NOT_CONFIRMED': '延迟付款 - 未确认',
  'payment_status.DYN.DELAY_PAY_NOT_CONFIRMED.FREE': '免费 - 未确认',
  'payment_status.DYN.DELAY_PAY': '准备到达时付款',
  'payments.validate': '确认',
  'documentContinue.title': '继续购物',
  'bt.available_devices': '可用蓝牙设备',
  'bt.no_available_devices': '未检测到可用蓝牙设备',
  'emailSend.title': '电子邮件验证',
  'emailSend.description': '为了验证您的账户，您必须点击发送到您电子邮件中的验证链接，24小时内有效。',
  'emailValid.title': '账户已验证',
  'emailValid.description': '您的 {appName} 账户已成功验证。您现在可以使用您的凭证登录个人空间。',
  'documentManagement.title': '申请',
  'preenroll.title': '预注册',
  'passportEmbassy.title': '大使馆护照',
  'zwevisa.title': '签证',
  'passwordSend.title': '确认已发送',
  'passwordSend.description': '您已收到一封确认邮件，其中包含一个重置密码的链接。您有24小时的时间点击它。',
  'forgotPassword.title': '忘记密码',
  'forgotPassword.description': '要重置密码，请在下方输入您的账户电子邮件。',
  'forgotPassword.description.electron': '要重置密码，请在下方输入您的账户电子邮件。如果您正在尝试恢复<b>活动目录</b>账户的密码，请联系支持。',
  'passwordNew.title': '新密码',
  'modifiedPassword.title': '密码已更改',
  'modifiedPassword.description': '密码已更改，请重新登录。',
  'people.title.DYN.': '已保存人员',
  'people.addPerson.DYN.': '创建新人员',
  'meansPayment.title': '支付方式',
  'onlinePayment.title': 'PayPal支付',
  'onlinePayment.pay': '支付',
  'qrPayment.title': '二维码支付',
  'form.expireDate': '到期日期',
  'successPayment.title': '订单确认',
  'trackingControl.title.DYN.': '跟踪此申请',
  'modifyData': '修改数据',
  'stopModifyData': '停止修改数据',
  'askVisa': '申请签证',
  'peopleNew.title.DYN.': '新人员',
  'peopleFound.title.DYN.': '找到的人员',
  'peopleFound.description.DYN.': '输入信息对应的人员已被添加到保存的人员列表中。',
  'payment.commandHistory': '支付历史',
  'menu.placesPerm': '地点和权限',
  'block.message': '您想要封锁此用户吗？',
  'menu.addPlace': '添加地点',
  'label.numberAccount': '账户号',
  'place.sheet.open': '打开地点信息页面',
  'place.delete': '删除与此地点的链接',
  'place.update.success': '地点已成功更新。',
  'place.new': '新地点',
  'place.create': '创建地点',
  'place.add.ask': '您想要将此位置链接到此用户吗？',
  'place.delete.link': '删除与此地点的链接',
  'place.delete.link.ask': '您确定要取消与此地点的链接吗？',
  'place.delete.link.done': '您已成功删除与地点的链接。',
  'user.new': '新用户',
  'user.create': '创建用户',
  'user.created': '新用户创建成功。现在可以使用此账户。',
  'user.sheet.open': '打开用户信息页面',
  'payment.sheet.open': '打开支付信息页面',
  'err.createplace': '无法创建。ID已存在。',
  'place.parent': '父地点',
  'dropdown.qr': '扫描二维码',
  'dropdown.pass': '扫描文件',
  'err.noReader': '读卡器未连接。请连接读卡器以继续。',
  'err.noCard': '读卡器中未检测到有效的生物识别文件。这可能是由于使用了非生物识别文件、未经授权的副本或伪造的文件，或读取天线出现故障。',
  'err.noConnect': '此文件不符合ICAO标准协议。这可能是由于使用了非生物识别文件、未经授权的副本或伪造的文件，或读取天线出现故障。',
  'err.noBAC': '无法建立与文件的安全通道，它是真实的吗？请手动全面核实此文件并询问持有者。',
  'err.alteredDoc': '无法读取文件字段，它是真实的吗？请手动全面核实此文件并询问持有者。',
  'err.revokedDocSigner': '此文件的签发者已被其发行机构吊销。可能是文件被欺诈性签发。请全面询问持有者。',
  'err.unverifiedDoc': '无法验证文件的有效性，身份验证协议错误，这可能表明该文件是在非ICAO主列表国签发的，可能是伪造的文件，或读取天线出现故障。',
  'err.noPassiveAuthentication': '无法验证文件的有效性，身份验证协议错误，可能是伪造的文件，或读取天线出现故障。',
  'err.noResult': '未找到文件',
  'payment.new.DYN.': '新签证出口',
  'payment.created.register': '支付已注册',
  'payment.created': '您的支付已保存，现在可以在支付列表中查看。',
  'payment.created.qr': '包含生成的二维码的电子邮件已发送到所提供的电子邮件地址。',
  'idcard.number': '身份证号',
  'form.userCreator': '由用户创建',
  'form.userRefund': '由用户退款',
  'form.userConsumed': '由用户消费',
  'PRICEUP': '价格 0-9',
  'PRICEDOWN': '价格 9-0',
  'RECENT': '最新',
  'LATEST': '最旧',
  'STATUSUP': '状态 a-z',
  'STATUSDOWN': '状态 z-a',
  'payment.success': '您的支付已注册',
  'payment.consume.ask.DYN.': '您确定要办理此申请的入境/出境手续吗？',
  'checkinOut.refuse': '您确定要拒绝此申请吗？',
  'payment.duplicate': '复制',
  'payment.duplicate.ask': '您确定要复制此支付吗？',
  'payment.duplicate.done': '您的支付已成功复制',
  'tooltip.duplicatePayment': '复制此支付以允许重复使用',
  'payment.refund.ask': '您确定要退款此支付吗？',
  'payment.refund.done': '您的支付已成功退款',
  'payment.refund.exist': '此支付已被退款',
  'payment.paid.error': "您的支付需要在状态 '完成' 下",
  'block.done': '账户已被封锁',
  'block.unblock': '账户已被解封',
  'place-add.add': '添加地点',
  'permission.title': '需要权限: 相机',
  'qr.see': '查看二维码',
  'qr.desc.DYN.': '这是申请的二维码。它将在打印时出现，并将发送到注册时输入的电子邮件地址。',
  'dashboard.place.verif': '如果您还没有输入地点，请进行输入',
  'block.yourself': '您不能封锁自己',
  'lastPlace.delete': '此账户中的最后一个地点即将被删除。这样做将使此账户无法使用。继续吗？',
  'place.add.done': '该地点已成功添加到此用户。',
  'no.connection': '要访问此页面，您必须连接到互联网。请重新登录',
  'place.delete.success': '该地点已被删除。',
  'wrong.current': '您输入了错误的当前密码',
  'no.place': '此账户没有地点。',
  'email.error': '相似的电子邮件已经存在',
  'email.notexist': '电子邮件不存在',
  'one.payment': '您必须至少创建一个或更多支付并/或进行筛选。',
  'err.client.extended.uuidUsed': '此支付已被消费',
  'client.extended.uuidUsed': '此支付已被消费',
  'no.activecamera': '未发现活跃的相机',
  'no.accessPermission': '此账户没有访问权限',
  'print.name': '打印机',
  'print.success': '您的票已打印',
  'print.need': '您必须先连接到打印机才能打印',
  'printer.connect': '您现在已连接到打印机：',
  'permission.desc': '您要使用的服务需要使用设备的相机权限',
  'createPeople.ask.DYN.': '您确定要创建此新人员吗？',
  'createPeopleDuplicate.ask.DYN.': '似乎您的注册人员中已有同名人员。您仍然想创建此人吗？',
  'deletePerson.DYN.': '删除此人',
  'deletePerson.ask.DYN.': '您确定要删除此人吗？',
  'deletePerson.valid.DYN.': '此人已被删除',
  'personModification.ask.DYN.': '您确定要更改此人的数据吗？',
  'personModification.valid.DYN.': '此人的数据已被修改',
  'noPayment': '无支付',
  'selfie.desc': '文件申请需要照片，请确保在良好的光线下，保持手机稳定，避免照片模糊。同时，确保照片中您的面部细节清晰可见。',
  'ZWEVISA.title': '签证',
  'EMBASSYPASS.title': '大使馆护照',
  'PREENROLL.title': '预注册',
  'DYN.NOK': '请求被拒绝',
  'WIP': '工作进行中',
  'menu.requests.DYN.': '申请',
  'menu.createRequests.DYN.': '新申请',
  'request_state.SUBMITTED': '已提交',
  'request_state.CONFIRMED': '已确认',
  'request_state.TREATED': '已处理',
  'request_state.TRANSFERRED': '已转移',
  'request_state.CANCELLED': '已取消',
  'request_state.REFUSED': '已拒绝',
  'request_state.UNUSABLE': '不可用',
  'request_state.NULL': '未支付',
  'request_state.NONE': '-- 无筛选 --',
  'ask.disconnect': '您确定要断开连接吗？',
  'global.yes': '是',
  'applicant.gender.male': '男性',
  'applicant.gender.female': '女性',
  'applicant.gender.other': '其他',
  'marital.status.single': '单身',
  'marital.status.married': '已婚',
  'marital.status.separated': '分居',
  'marital.status.divorced': '离婚',
  'marital.status.widowed': '丧偶',
  'marital.status.religiously_married': '宗教婚姻',
  'marital.status.married_according_to_custom': '习俗婚姻',
  'marital.status.other': '其他',
  'marital.status.unknown': '未知',
  'request_state.PROPOSED': '待付款',
  'request_state.PAID': '已完成',
  'request_state.USED': '已关闭',
  'request_state.DUPLICATED': '已复制',
  'request_state.REFUNDED': '已退款',
  'request_state.EXPIRED': '已拒绝',
  'request_state.PAID_NOT_CONFIRMED': '等待审核',
  'request_state.DELAY_PAY_NOT_CONFIRMED': '稍后支付 - 未确认',
  'request_state.DELAY_PAY': '准备到达后支付',
  'payment_status.DYN.0': '待付款',
  'payment_status.DYN.1': '准备办理入境',
  'payment_status.DYN.6': '等待审核',
  'payment_status.DYN.2.9': '等待监督',
  'payment_status.DYN.2.10': '已监督',
  'payment_status.desc.DYN.2.10': '申请已由监督员审核，准备由边境检查官处理。',
  'payment_status.desc.DYN.2.9': '申请正在等待监督。监督员可能需要在边境检查官处理前审核申请。',
  'payment_status.DYN.7': '等待更正',
  'payment_status.DYN.8': '稍后支付 - 未确认',
  'payment_status.DYN.9': '准备到达后支付',
  'payment_status.DYN.9.entry': '准备办理入境',
  'payment_status.DYN.9.exit': '准备办理出境',
  'payment_status.DYN.2': '已出境',
  'payment_status.DYN.3': '已复制',
  'payment_status.DYN.4': '已退款',
  'payment_status.DYN.5': '已拒绝',
  'payment_status.extension.DYN.5': '延期被拒绝',
  'payment_status.DYN.5.blacklisted': '已拒绝 - 被列入黑名单',
  'createPeople.success.DYN.': '人员已成功创建',
  'adminRequestResult.title.DYN.': '已选申请 - {paymentID}',
  'form.paymentType': '支付类型',
  'payment.type.online': '在线',
  'payment.type.offline': '离线',
  'request.state.DYN.': '申请状态',
  'form.birthDate': '出生日期',
  'form.birthCountry': '出生国家',
  'form.placeOfBirth': '出生城市',
  'form.residenceAdress': '居住地址',
  'form.maritalStatus': '婚姻状况',
  'form.departureDate': '出发日期',
  'form.arrivalDate': '到达日期',
  'form.referencePreviousVisa': '先前签证参考',
  'form.passportNumber': '护照号码',
  'form.hostName': '主办方名称',
  'form.purposeOfVisit': '访问目的',
  'form.previousConvictionsHome': '本国的前科记录',
  'form.spouse.birthDay': '配偶的出生日期',
  'form.spousePassportNumber': '配偶的护照号码',
  'form.spousePlaceOfBirth': '配偶的出生地',
  'form.dependantFullName': '受扶养者的全名',
  'form.dependantPassportNumber': '受扶养者的护照号码',
  'form.dependantPlaceOfBirth': '受扶养者的出生地',
  'form.dependantBirthDay': '受扶养者的出生日期',
  'form.existingValidEntryReferenceOfficer': '入境参考官员',
  'officer.unknown': '未知官员',
  'err.ResidencePermitNumber.pattern': '居留许可号码只能包含大写字母和数字',
  'global.approve': '批准',
  'global.refuse': '拒绝',
  'global.suspend': '请求修订',
  'personal.data': '个人数据',
  'contact.data': '联系数据',
  'divers.data.DYN.': '旅行详情',
  'dashboard.noPreviousApplication': '没有找到先前的申请',
  'divers.data.DYN.zwevisa': '旅行详情',
  'divers.data.DYN.pass': '请求详情',
  'dependant.data': '受扶养者数据',
  'spouse.data': '配偶数据',
  'payment.review.approve.ask.DYN.': '您确定要将此申请审核为<b>推荐</b>吗？',
  'payment.review.refuse.ask.DYN.': '您确定要将此申请审核为<b>不推荐</b>吗？',
  'payment.review.refuse.ask.extension.DYN.': '您确定要将此延期请求审核为<b>不推荐</b>吗？',
  'payment.review.approve.extension.ask.DYN.': '您确定要<b>批准</b>此延期请求吗？',
  'payment.validate.ask.DYN.': '您确定要<b>批准</b>此申请吗？',
  'payment.validate.extension.ask.DYN.': '您确定要<b>批准</b>此延期请求吗？',
  'error.payment.suspend.error.DYN.': '暂停申请时发生错误。',
  'global.no': '否',
  'global.Yes': '是',
  'global.No': '否',
  'documents': '文件',
  'data.biographic': '护照生物页面',
  'residence.proof': '居住证明',
  'address.destination': '目的地地址',
  'previous.visa': '先前签证',
  'invite.letter': '邀请函',
  'hostInvitation.letter': '主办方的邀请函',
  'proof.residenceHost': '主办方的居住证明',
  'hostResidential.status': '主办方的居住状态',
  'reasonOfVisit.proof': '访问目的的证明',
  'inviteBusiness.letter': '发件公司的商务函',
  'business.profile': '旅行者的职业档案',
  'application.letter': '申请函',
  'acceptanceFromScool.letter': '确认函',
  'date.creation': '创建日期',
  'document.Passport': '护照',
  'completeName': '全名',
  'price': '价格',
  'global.retry': '重试',
  'err.loginWeak': '连接问题，请重试',
  'URGENTPASS.title': '紧急护照',
  'refusalReason': '拒绝原因',
  'error.payment.noRefuseReason': '请输入消息。',
  'error.payment.noSuspendReason': '请输入暂停原因。此原因将发送给客户。',
  'refusal.desc.DYN.': '此申请已被拒绝。',
  'refusal.desc.extension.DYN.': '此延期请求已被拒绝。',
  'approval.desc.DYN.': '此申请已被批准。',
  'approval.desc.extension.DYN.': '此延期请求已被批准。',
  'review.approval.desc.DYN.': '此申请符合要求。',
  'review.approval.desc.extension.DYN.': '此延期请求符合要求。',
  'review.refusal.desc.DYN.': '此申请不符合要求。',
  'review.refusal.desc.extension.DYN.': '此延期请求不符合要求。',
  'err.getUsers: client.extended.notActiveToken': '您的会话已过期。请重新登录。',
  'VISA_DOUBLE.title': '双次入境签证',
  'VISA_KAZA.title': 'Kaza签证',
  'history': '历史记录',
  'menu.people.DYN.': '已保存的人员',
  'DYN.XBA': '巴林',
  'DYN.AGO': '安哥拉',
  'DYN.ABW': '阿鲁巴',
  'DYN.ATG': '安提瓜和巴布达',
  'DYN.BHS': '巴哈马',
  'DYN.BRB': '巴巴多斯',
  'DYN.BLZ': '伯利兹',
  'DYN.BWA': '博茨瓦纳',
  'DYN.CYM': '开曼群岛',
  'DYN.CYP': '塞浦路斯',
  'DYN.FJI': '斐济',
  'DYN.COD': '刚果民主共和国',
  'DYN.GHA': '加纳',
  'DYN.GRD': '格林纳达',
  'DYN.HKG': '中国香港特别行政区',
  'DYN.KEN': '肯尼亚',
  'DYN.KIR': '基里巴斯',
  'DYN.JAM': '牙买加',
  'DYN.LDW': '背风群岛',
  'DYN.LSO': '莱索托',
  'DYN.MDG': '马达加斯加',
  'DYN.MWI': '马拉维',
  'DYN.MYS': '马来西亚',
  'DYN.MDV': '马尔代夫',
  'DYN.MLT': '马耳他',
  'DYN.MUS': '毛里求斯',
  'DYN.MSR': '蒙特塞拉特',
  'DYN.MOZ': '莫桑比克',
  'DYN.NAM': '纳米比亚',
  'DYN.NRU': '瑙鲁',
  'DYN.LCA': '圣卢西亚',
  'DYN.VCT': '圣文森特和格林纳丁斯',
  'DYN.WSM': '西萨摩亚',
  'DYN.SYC': '塞舌尔',
  'DYN.SGP': '新加坡',
  'DYN.SLB': '所罗门群岛',
  'DYN.ZAF': '南非',
  'DYN.KNA': '圣基茨和尼维斯',
  'DYN.SWZ': '斯威士兰',
  'DYN.TON': '汤加',
  'DYN.TTO': '特立尼达和多巴哥',
  'DYN.TCA': '特克斯和凯科斯群岛',
  'DYN.TUV': '图瓦卢',
  'DYN.UGA': '乌干达',
  'DYN.TZA': '坦桑尼亚联合共和国',
  'DYN.VUT': '瓦努阿图',
  'DYN.VAT': '梵蒂冈',
  'DYN.VEN': '委内瑞拉（玻利瓦尔共和国）',
  'DYN.USA': '美利坚合众国',
  'DYN.URY': '乌拉圭',
  'DYN.UZB': '乌兹别克斯坦',
  'DYN.UKR': '乌克兰',
  'DYN.ARE': '阿拉伯联合酋长国',
  'DYN.GBR': '大不列颠及北爱尔兰联合王国',
  'DYN.TUR': '土耳其',
  'DYN.TKM': '土库曼斯坦',
  'DYN.SWE': '瑞典',
  'DYN.CHE': '瑞士',
  'DYN.TJK': '塔吉克斯坦',
  'DYN.KAZ': '哈萨克斯坦',
  'DYN.SUR': '苏里南',
  'DYN.ESP': '西班牙',
  'DYN.SVK': '斯洛伐克',
  'DYN.SVN': '斯洛文尼亚',
  'DYN.SEN': '塞内加尔',
  'DYN.SRB': '塞尔维亚',
  'DYN.SMR': '圣马力诺',
  'DYN.STP': '圣多美和普林西比',
  'DYN.NLD': '荷兰',
  'DYN.NCL': '新喀里多尼亚',
  'DYN.NZL': '新西兰',
  'DYN.NIC': '尼加拉瓜',
  'DYN.MEX': '墨西哥',
  'DYN.FSM': '密克罗尼西亚联邦',
  'DYN.MDA': '摩尔多瓦',
  'DYN.MCO': '摩纳哥',
  'DYN.MHL': '马绍尔群岛',
  'DYN.LVA': '拉脱维亚',
  'DYN.NFK': '诺福克岛',
  'DYN.MNP': '北马里亚纳群岛',
  'DYN.NOR': '挪威',
  'DYN.PLW': '帕劳',
  'DYN.PSE': '巴勒斯坦',
  'DYN.PAN': '巴拿马',
  'DYN.PNG': '巴布亚新几内亚',
  'DYN.PRY': '巴拉圭',
  'DYN.PER': '秘鲁',
  'DYN.POL': '波兰',
  'DYN.PRT': '葡萄牙',
  'DYN.PRI': '波多黎各',
  'DYN.REU': '留尼汪',
  'DYN.ROU': '罗马尼亚',
  'DYN.RUS': '俄罗斯联邦',
  'DYN.RWA': '卢旺达',
  'DYN.LIE': '列支敦士登',
  'DYN.LTU': '立陶宛',
  'DYN.LUX': '卢森堡',
  'DYN.MAC': '中国澳门特别行政区',
  'DYN.JPN': '日本',
  'DYN.KWT': '科威特',
  'DYN.KGZ': '吉尔吉斯斯坦',
  'DYN.KOR': '韩国',
  'DYN.GUY': '圭亚那',
  'DYN.HTI': '海地',
  'DYN.HND': '洪都拉斯',
  'DYN.IRL': '爱尔兰',
  'DYN.ISR': '以色列',
  'DYN.ITA': '意大利',
  'DYN.HUN': '匈牙利',
  'DYN.ISL': '冰岛',
  'DYN.IND': '印度',
  'DYN.IDN': '印度尼西亚',
  'DYN.IRN': '伊朗',
  'DYN.GUM': '关岛',
  'DYN.GTM': '危地马拉',
  'DYN.GIB': '直布罗陀',
  'DYN.GRC': '希腊',
  'DYN.GEO': '格鲁吉亚',
  'DYN.DEU': '德国',
  'DYN.DNK': '丹麦',
  'DYN.EST': '爱沙尼亚',
  'DYN.ETH': '埃塞俄比亚',
  'DYN.FIN': '芬兰',
  'DYN.FRA': '法国',
  'DYN.GUF': '法属圭亚那',
  'DYN.PYF': '法属波利尼西亚',
  'DYN.ATF': '法属南部领土',
  'DYN.CZE': '捷克共和国',
  'DYN.COM': '科摩罗',
  'DYN.DOM': '多米尼加共和国',
  'DYN.ECU': '厄瓜多尔',
  'DYN.EGY': '埃及',
  'DYN.SLV': '萨尔瓦多',
  'DYN.GNQ': '赤道几内亚',
  'DYN.CHL': '智利',
  'DYN.CHN': '中国',
  'DYN.CHN_NT': '中国（非旅游）',
  'DYN.COK': '库克群岛',
  'DYN.CRI': '哥斯达黎加',
  'DYN.HRV': '克罗地亚',
  'DYN.CUB': '古巴',
  'DYN.BDI': '布隆迪',
  'DYN.CAN': '加拿大',
  'DYN.CPV': '佛得角',
  'DYN.BRA': '巴西',
  'DYN.VGB': '英属维尔京群岛',
  'DYN.BRN': '文莱达鲁萨兰国',
  'DYN.BGR': '保加利亚',
  'DYN.BMU': '百慕大',
  'DYN.BTN': '不丹',
  'DYN.BIH': '波斯尼亚和黑塞哥维那',
  'DYN.BLR': '白俄罗斯',
  'DYN.BEL': '比利时',
  'DYN.BHR': '巴林',
  'DYN.ARG': '阿根廷',
  'DYN.ARM': '亚美尼亚',
  'DYN.AUS': '澳大利亚',
  'DYN.AUT': '奥地利',
  'DYN.AZE': '阿塞拜疆',
  'DYN.ALB': '阿尔巴尼亚',
  'DYN.DZA': '阿尔及利亚',
  'DYN.AIA': '安圭拉',
  'DYN.BGD': '孟加拉国',
  'DYN.BEN': '贝宁',
  'DYN.AFG': '阿富汗',
  'DYN.BOL': '玻利维亚',
  'DYN.BFA': '布基纳法索',
  'DYN.KHM': '柬埔寨',
  'DYN.CMR': '喀麦隆',
  'DYN.CIV': '科特迪瓦',
  'DYN.CAF': '中非共和国',
  'DYN.TCD': '乍得',
  'DYN.COL': '哥伦比亚',
  'DYN.ERI': '厄立特里亚',
  'DYN.COG': '刚果布拉柴维尔',
  'DYN.PRK': '朝鲜民主主义人民共和国',
  'DYN.GAB': '加蓬',
  'DYN.GMB': '冈比亚',
  'DYN.DJI': '吉布提',
  'DYN.GIN': '几内亚科纳克里',
  'DYN.GNB': '几内亚比绍',
  'DYN.IRQ': '伊拉克',
  'DYN.KOS': '科索沃',
  'DYN.LAO': '老挝人民民主共和国',
  'DYN.JOR': '约旦',
  'DYN.LBR': '利比里亚',
  'DYN.LBY': '利比亚',
  'DYN.MLI': '马里',
  'DYN.QAT': '卡塔尔',
  'DYN.REF': '难民',
  'DYN.PHL': '菲律宾',
  'DYN.OMN': '阿曼',
  'DYN.PAK': '巴基斯坦',
  'DYN.LBN': '黎巴嫩',
  'DYN.MRT': '毛里塔尼亚',
  'DYN.MNG': '蒙古',
  'DYN.MNE': '黑山',
  'DYN.NER': '尼日尔',
  'DYN.NGA': '尼日利亚',
  'DYN.MMR': '缅甸',
  'DYN.MAR': '摩洛哥',
  'DYN.NPL': '尼泊尔',
  'DYN.SAU': '沙特阿拉伯',
  'DYN.SLE': '塞拉利昂',
  'DYN.SOM': '索马里',
  'DYN.LKA': '斯里兰卡',
  'DYN.SSD': '南苏丹',
  'DYN.SDN': '苏丹',
  'DYN.THA': '泰国',
  'DYN.MKD': '前南斯拉夫马其顿共和国',
  'DYN.TGO': '多哥',
  'DYN.SYR': '叙利亚阿拉伯共和国',
  'DYN.TWN': '台湾',
  'DYN.TUN': '突尼斯',
  'DYN.VNM': '越南',
  'DYN.YEM': '也门',
  'DYN.TLS': '东帝汶',
  'DYN.AND': '安道尔',
  'DYN.VIR': '美属维尔京群岛',
  'DYN.XKX': '科索沃',
  'DYN.ZWE': '津巴布韦',
  'DYN.ZMB': '赞比亚',
  'DYN.ASM': '美属萨摩亚',
  'DYN.DMA': '多米尼克',
  'DYN.XXA': '无国籍',
  'DYN.XXB': '难民（日内瓦公约）',
  'DYN.XXC': '难民（其他）',
  'DYN.UNA': '联合国机构',
  'DYN.UNO': '联合国组织',
  'document.type.DYN.': '申请类型',
  'dependantIndex': '依赖人 {index}',
  'form.spouseFullName': '配偶的全名',
  'qrDesc.valid': '在进入或离开国家时，请在签证检查点出示此二维码。没有有效的二维码，您不能旅行。',
  'err.pay': '支付过程中发生错误。请重试。',
  'payment.noEvents': '此申请当前不包括任何与旅行相关的处理（申请的使用情况）。',
  'global.cancel': '取消',
  'end.suspend': '完成修改',
  'trips.title': '跟踪申请',
  'trips.desc': '申请',
  'BatchId': '申请参考编号',
  'newBatchId.desc': '请输入此次旅行的名称。',
  'personLinkType.DYN.0': '未知',
  'personLinkType.DYN.1': '子女',
  'personLinkType.DYN.2': '父母',
  'personLinkType.DYN.3': '配偶',
  'personLinkType.DYN.4': '其他',
  'personLinkType.DYN.5': '本人',
  'batchIds.desc': '与参考编号 {trip} 相关的申请：',
  'trip.name': '申请参考编号',
  'visaIntro.validFrom': '开始日期',
  'visaIntro.validUntil': '到期日期',
  'visaIntro.usageCount': '允许使用次数',
  'client.extended.passportNumberAlreadyExists': '此护照号码已被使用。请输入另一个号码。',
  'client.extended.alreadyDecided': '您已审查过此申请。您无法再次审查。',
  'client.extended.outOfUsage': '此申请已超过有效期',
  'global.review': '审查',
  'error.review.noChoice': '请选择一个审查状态以继续。',
  'all.reviews': '该申请的所有审查',
  'all.reviews.extension': '该延期请求的所有审查',
  'validate.desc': '此申请已于 {date} 被用户审查并批准',
  'validate.extension.desc': '此延期请求已于 {date} 被用户审查并批准',
  'refusal.review.desc': '此申请已于 {date} 被用户审查并拒绝',
  'refusal.review.extension.desc': '此延期请求已于 {date} 被用户审查并拒绝',
  'refusal.review.desc.blacklisted': '此申请已于 {date} 被用户审查并拒绝且列入黑名单',
  'approve.text': '此申请已被批准。',
  'pending.review.desc': '此申请的修改请求已于 {date} 被用户提交给申请人',
  'global.reason': '原因',
  'pending.desc': '此申请当前等待客户的修改。',
  'successRequest.title': '请求已成功提交',
  'amountDue': '价格：',
  'amountDue.total.now': '当前总应付金额：',
  'amountDue.total.later': '在官员处应付总金额：',
  'noPrint.mobile': '移动设备不支持打印页面',
  'onArrival.reset': '开始新流程',
  'onArrival.reset.ask': '您真的想开始一个新流程吗？',
  'stillHere': '您还在吗？该流程将在20秒后重置。',
  'print.request': '打印申请',
  'EXPIRED.globalExplain': '此请求已被拒绝。不符合我们的标准。',
  'payment_status.desc.DYN.7': '此申请当前等待客户的修改。',
  'payment_status.DYN.6.review': '等待审查 - {reviewCount}/2',
  'payment_status.extension.DYN.6': '等待审查',
  'payment_status.extension.DYN.6.review': '等待审查 - {reviewCount}/1',
  'payment_status.desc.DYN.6.review': '此申请当前等待审查，已审查 {reviewCount} 次。',
  'payment_status.DYN.6.finalReview': '等待最终审查',
  'payment_status.extension.DYN.6.finalReview': '等待最终审查',
  'payment_status.desc.DYN.6.finalReview': '此申请已被审查，当前等待最终审查。',
  'payment_status.desc.DYN.0': '此申请当前等待支付机构的支付验证。如果尚未支付，可以现在完成。',
  'payment_status.desc.DYN.5': '此申请已被拒绝。',
  'payment_status.desc.DYN.5.blacklisted': '此申请已被拒绝且该人被列入黑名单。',
  'payment_status.desc.DYN.5.checkIn': '此申请在官员处的签到时被拒绝。',
  'payment_status.desc.DYN.5.checkIn.reason': '此申请在官员处的签到时被拒绝。原因:  {reason}',
  'payment_status.DYN.5.checkIn': '签到时被拒绝',
  'payment_status.desc.DYN.5.checkOut': '此申请在官员处的签退时被拒绝。',
  'payment_status.DYN.5.checkOut': '签退时被拒绝',
  'payment_status.desc.DYN.9': '此申请已准备好在官员处支付。支付后可完成签到。',
  'payment_status.desc.DYN.9.entry': '此申请已准备好在官员处签到。',
  'payment_status.desc.DYN.9.exit': '此申请已准备好签退，并需支付官员处签发的边境通行证。',
  'payment_status.DYN.2.out': '准备签退',
  'payment_status.DYN.2.outFinish': '签退完成',
  'payment_status.DYN.2.closed': '已关闭',
  'payment_status.desc.DYN.2.closed': '此申请已关闭。',
  'payment_status.desc.DYN.2.zweexit': '此申请已准备好在官员处签退。',
  'payment_status.DYN.2.entryFinish': '签到完成',
  'payment_status.DYN.2.in': '准备签到',
  'payment_status.desc.DYN.2.out': '此申请已签到。下一步是在官员处签退。',
  'payment_status.desc.DYN.2.outFinish': '此申请已签退。客户现在可以旅行。',
  'payment_status.desc.DYN.2.entryFinish': '此申请已签到。客户现在可以进入该国。',
  'payment_status.desc.DYN.2.in': '此申请等待在官员处签到。',
  'ask.isArrivalPaid': '以下支付必须立即以任何以下货币支付：',
  'ask.isArrivalPaid.exit': '边境通行证必须立即以任何以下货币支付：',
  'ask.isArrivalPaid.confirm': '您确认已完成支付吗？如果确认，请输入支付参考、支付方式和使用的货币。您还可以更改最长停留日期（只能缩短日期）。',
  'ask.isArrivalPaid.confirm.exit': '您确认已完成支付吗？如果确认，请输入支付参考和使用的货币。',
  'ask.checkoutExpired.confirm': '您确认已完成支付吗？如果确认，请输入支付参考和使用的货币。',
  'no_trips': '您没有任何旅行。',
  'err.canActivate': '发生错误',
  'form.passportNumber.dateOfIssue': '护照签发日期',
  'form.passportNumber.dateOfExpiry': '护照到期日期',
  'form.passportNumber.placeOfIssue': '护照签发地',
  'nextOfKin.data': '紧急联系人 / 近亲',
  'form.otherLinkType': '指定关系类型',
  'camera.problem.manual': '您即将未经客户照片检查出此申请。您确定要继续吗？',
  'camera.problem.button': '摄像头有问题吗？',
  'global.noFilter': '–无筛选–',
  'zweentry': '无需签证的入境',
  'zweentry.title': '无需签证的入境',
  'free.charge': '免费',
  'camera.init.error': '初始化摄像头时发生错误。您想在没有客户照片的情况下签到/签退此申请吗？',
  'error.payment.noPaymentReference': '请输入支付参考、支付方式和使用的货币。',
  'paymentReference.ask': '支付参考',
  'paymentReference.askExpired': '超期费用的支付参考',
  'session.expired': '您的会话已过期。请重新登录。',
  'phone.pattern': '(例如：+263771234567)',
  'global.receipt.id': '申请 ID：{paymentId}',
  'ask.place.updatePermissions': '您确定要更新此地点的权限吗？',
  'place.updatePermissions.success': '此地点的权限已成功更新。',
  'err.place.updatePermissions': '更新地点权限时发生错误。',
  'global.urgent': '紧急',
  'form.usageAfter': '有效期从',
  'form.usageUntil': '有效期至',
  'form.localUsageUntil': '最长停留日期',
  'form.timeslot': '时间段',
  'internalReference': '总部参考',
  'payment_status.DYN.6.0': '等待审查 0/2',
  'payment_status.DYN.6.1': '等待审查 1/2',
  'payment_status.DYN.6.2': '等待最终审查',
  'payment_status.DYN.8.0': '稍后支付 - 未确认',
  'payment_status.DYN.2.0': '签到完成',
  'payment_status.DYN.2.4': '准备签退',
  'payment_status.DYN.2.5': '签退完成',
  'payment_status.DYN.2.6': '签到时被拒绝',
  'payment_status.DYN.2.7': '签退时被拒绝',
  'payment_status.DYN.2.8': '已关闭',
  'payment_status.extension.DYN.6.0': '等待审查 0/1',
  'payment_status.extension.DYN.6.2': '等待最终审查',
  'payment_status.extension.DYN.7': '等待更正',
  'payment_status.extension.DYN.9': '延期已验证',
  'payment_status.extension.DYN.0': '待付款',
  'internalReference.create': '添加总部参考',
  'internalReference.edit': '编辑总部参考',
  'timeslot.set': '设置时间段',
  'timeslot.setNew': '设置新时间段',
  'internalReference.ask.edit': '请输入新的总部参考。',
  'internalReference.ask.create': '请输入总部参考。',
  'internalReference.done.create': '总部参考已成功添加。',
  'internalReference.done.edit': '总部参考已成功编辑。',
  'error.internalReference': '添加/编辑总部参考时发生错误。',
  'error.paymentUntil.expired': '此申请已超出有效期。您可以继续为客户办理签退手续，但请注意，由于申请的过期状态，需支付100美元的费用。支付必须立即以任何以下货币进行：',
  'internalReference.desc': '为此申请添加总部参考（例如：140_2024）。',
  'titlePrint': '申请  {paymentID}',
  'title.visaReference': '关联的申请',
  'titlePrint.extension': '延期请求  </br> <b>{paymentID}</b>',
  'globalStatus.valid': '有效',
  'PENDING.globalExplain': '此请求等待修改。请检查信息并进行修改。',
  'PAID_NOT_CONFIRMED.globalExplain': '此请求等待我们服务的确认。',
  'PROPOSED.globalExplain': '此请求正在等待支付。如果您尚未确认支付，可以现在进行。',
  'afterWithoutUntil': '您被允许从 {dateAfter} 到 {deadlineDate} 之间入境。',
  'afterWithoutUntilAndMillis': '您被允许从 {dateAfter} 开始旅行。',
  'afterAndUntil': '您被允许从 {dateAfter} 到 {dateUntil} 之间旅行。',
  'photo.current': '当前照片',
  'photo.scanned': '从护照扫描的照片',
  'createdAt': '创建日期',
  'all.infos': '关于此申请的所有信息',
  'afterRefused': '声明的旅行日期：{dateAfter}。',
  'DYN.paymentError.desc.success': '您的订单已成功记录。如果此申请的任何部分需要我们团队的批准，一旦完成此过程，您将收到通知。否则，请知悉我们已收到您的请求。<p><b>感谢您选择我们的服务。</b></p>',
  'sinceOneWeek': '请注意，此文件申请已处于等待审查状态超过一周。',
  'client.extended.onlyAdminDecide': '与您相同资历的工作人员已审查过此申请。您无法再次审查。',
  'error.paymentUntil.before': '日期太早。此申请将从 {dateAfter} 开始生效。',
  'applicant.gender.FEMALE': '女性',
  'applicant.gender.MALE': '男性',
  'entry.consume': '入境',
  'exit.consume': '出境',
  'scan.noConsumeMode': '作为边境官员，您负责管理入境和出境。请选择与您当前任务相对应的选项：处理入境或管理出境。',
  'scan.noVisaFound': '未找到此人处于"准备签退"状态的出境记录。您想创建一个准备签退的记录吗？',
  'zweexit': '无需签证的出境',
  'err.scanPassport': '扫描护照时发生错误。请确保正确插入并重试。如果问题仍然存在，请重新启动应用程序或联系支持。',
  'exit.register': '记录出境',
  'entry.register': '记录入境',
  'exit.create': '创建无需签证的出境',
  'exit.ask': '您确定要为此人注册无需签证的出境吗？',
  'border': '边境官员',
  'global.signout': '登出',
  'search.manually': '手动搜索申请',
  'scan.applicationQr': '扫描申请二维码',
  'err.client.extended.maxUsageCountReached': '此申请的最大使用次数已达到。',
  'form.firstName.scanned': '扫描的名字',
  'form.lastName.scanned': '扫描的姓氏',
  'form.gender.scanned': '扫描的性别',
  'form.birthDate.scanned': '扫描的出生日期',
  'form.nationality.scanned': '扫描的国籍',
  'form.nationality': '国籍',
  'application.data': '申请数据',
  'no.passportPhoto': '无照片',
  'overstay': '逾期停留',
  'method.payment': '支付方式',
  'review.desc': '批准/拒绝',
  'approval.usageUntil.DYN.': '更改到期日期（可选）',
  'scanned.list': '找到的申请列表',
  'scanned.recommended': '推荐',
  'scanned.entriesUsed': '条已使用',
  'scanned.paid': '已付款',
  'visa.blacklist': '此签证申请已被列入黑名单。此人不得入境。',
  'scan.noEntryFound': '未找到此人处于"准备签到"状态的入境记录。您想创建一个准备签到的记录吗？',
  'global.syncing': '正在同步...',
  'payment.consume.error.DYN.': '处理申请时发生错误。',
  'tooltip.changeTimeslot': '修改时间段',
  'tooltip.transit': '勾选此复选框以作为边境官员管理过境。',
  'tooltip.Qr': '您可以直接扫描与申请相关的二维码，以找到该申请的详细信息。',
  'tooltip.arrivals': '选中此复选框，以边境官员身份管理入境。',
  'tooltip.departures': '选中此复选框，以边境官员身份管理出境。',
  'tooltip.searchManually': '使用多种标准搜索特定申请。',
  'tooltip.signout': '退出应用程序。',
  'tooltip.my_account': '访问您的帐户设置。',
  'tooltip.dashboard': '访问仪表板。',
  'tooltip.createRequests': '创建新申请。',
  'tooltip.trips': '查看您的申请状态，如果申请已批准，打印相关文件。',
  'tooltip.people': '管理与您的帐户相关的人员。',
  'tooltip.users': '管理应用程序的用户。',
  'tooltip.places': '管理应用程序的地点。',
  'tooltip.role': '您在应用程序中的角色和姓名。',
  'tooltip.exitRegister': '为此人手动注册无需签证的出境。',
  'tooltip.entryRegister': '为此人手动注册无需签证的入境。',
  'tooltip.support': '如果遇到任何问题，请联系支持。',
  'tooltip.chooseLang': '更改应用程序语言。当前仅支持英语。',
  'tooltip.changePassword': '更改您的密码。',
  'tooltip.internalReferenceNoFilter': '如果有内部参考，可点击该参考直接跳转到相关参考。',
  'tooltip.state': '根据状态过滤申请。',
  'tooltip.tableBatchId': '与申请相关的申请参考',
  'tooltip.tableState': '申请的状态',
  'tooltip.tableUsageAfter': '申请的开始日期',
  'tooltip.tableUsageUntil': '申请的到期日期',
  'tooltip.history': '您申请的支付历史。',
  'tooltip.addPerson': '添加与您的帐户相关的新人员。',
  'tooltip.urgent': '这意味着该申请被标记为紧急，应该尽快处理。',
  'tooltip.operationId': '申请的类型。',
  'tooltip.purposeOfVisit': '此次申请的访问目的。',
  'tooltip.amount': '此申请的价格。',
  'tooltip.paymentType': '此申请的支付类型。',
  'tooltip.paymentReference': '此申请的支付参考。',
  'tooltip.review': '审查此申请并批准或拒绝并添加评论。',
  'tooltip.revision': '要求客户修改申请。',
  'tooltip.approve': '作为最终决定批准此申请。您还可以添加评论。如果存在"黑名单"一词，则该人将被列入黑名单。',
  'tooltip.refuse': '作为最终决定拒绝此申请。您还可以添加评论。',
  'tooltip.qrSee': '查看此申请的二维码并打印与之相关的文件。',
  'tooltip.internalEdit': '编辑此申请的内部参考。',
  'tooltip.internalAdd': '为此申请添加内部参考。',
  'tooltip.printApplication': '打印包含所有信息的申请。',
  'tooltip.allReviews': '所有关于此申请的审查，包含日期和进行审查的用户。',
  'tooltip.version': '应用程序的当前版本。',
  'tooltip.consumeProfile.IN': '入境点捕获的照片。',
  'tooltip.consumeNoProfile.IN': '入境点未捕获照片。',
  'tooltip.consumeTime.IN': '入境点的日期和时间。',
  'tooltip.consumePlace.IN': '入境点的位置。',
  'tooltip.consumeProfile.OUT': '出境点捕获的照片。',
  'tooltip.consumeNoProfile.OUT': '出境点未捕获照片。',
  'tooltip.consumeTime.OUT': '出境点的日期和时间。',
  'tooltip.consumePlace.OUT': '出境点的位置。',
  'tooltip.passportComparison': '从护照扫描的信息。允许您将信息与申请的实际信息进行比较。',
  'tooltip.classicComparison': '申请的实际信息。允许您将信息与从护照扫描的信息进行比较。',
  'tooltip.trackingApplicationReference': '这些申请的申请参考',
  'tooltip.allTrackingInfo': '关于此申请的所有信息',
  'tooltip.trackingPrint': '打印与此申请相关的文件',
  'tooltip.docFirstName': '输入与护照上的姓名一致的名字。',
  'tooltip.docLastName': '输入与护照上的姓氏一致的姓氏。',
  'tooltip.docPassportNumber': '输入此人的护照号码。',
  'tooltip.docLinkType': '选择您与此人的关系类型。',
  'tooltip.docLinkTypeOther': '具体说明您与此人的关系类型。',
  'tooltip.applicationReferenceRequest': '请求的申请参考。每个请求都是唯一的，系统会自动生成。',
  'tooltip.portEntryRequest': '请求的入境口岸。即此人将进入国家的地点。',
  'tooltip.otherName': '输入申请人护照上的其他名字。',
  'tooltip.spouseCheckbox': '如果申请人有配偶，请勾选此框，并填写以下信息。',
  'tooltip.hostName': '将接待申请人的人/组织的名称。',
  'tooltip.scanPassport': '扫描申请人的护照，以查找与此护照相关的申请。如果没有找到申请，您可以创建一个新申请。',
  'tooltip.passportScanned': '从护照扫描的信息。',
  'tooltip.scannedCard': '使用扫描信息找到的类似申请。',
  'scan.error': '扫描文件时发生错误。',
  'tooltip.webcamProblems': '如果摄像头无法正常工作，您仍然可以在没有照片的情况下签到或签退申请。',
  'tooltip.checkOut': '为此人办理签退手续。',
  'tooltip.checkIn': '为此人办理签到手续。',
  'tooltip.consumeRefuse': '拒绝此人的入境或出境。',
  'tooltip.finalRefuse': '申请的最终决定。此人将不能入境。',
  'tooltip.finalApprove': '申请的最终决定。此人将能够入境或离境。',
  'tooltip.finalPending': '申请的最终决定。此人将不能入境，直到申请得到修改和批准。',
  'tooltip.finalRefuseBlacklist': '申请的最终决定。此人将不能入境，并被列入黑名单。',
  'photo.entryCountry.IN': '签到时的照片',
  'photo.entryCountry.OUT': '签退时的照片',
  'err.noPassiveAuthenticationCSCA': '文件有效，但无法验证其签发机构。',
  'err.passport.expired': '护照已过期。',
  'externalIndexedData': '找到多个护照',
  'client.extended.chargedBack': '此申请已被扣回。个人仍然可以继续办理签退手续，但必须以现金方式重新支付入境费。',
  'ask.chargedBack.confirm': '您确认此人已重新支付入境费吗？如果确认，请输入支付参考和使用的货币。',
  'error.payment.noReferenceChargedBack': '请输入支付参考和使用的货币。',
  'client.extended.entryChargedBack': '此申请已被扣回。此人不能继续办理签到，必须创建一个新的入境申请。',
  'tooltip.syncing': '当前正在同步的申请流程数量。',
  'adChoice': '与活动目录的连接',
  'external.down': '我们应用程序依赖的服务当前不可用。请稍后再试。',
  'global.connection.server': '服务不可用。很抱歉给您带来不便，请稍后重试。',
  'global.connection.problem': '上传您的请求时出错。请检查您是否未使用VPN、防火墙，确保您的互联网连接稳定，并重试。',
  'err.passport.issuedSoon': '护照最近签发（不到一个月）。',
  'global.reload': '重新加载',
  'error.passportScan': '证书字节（b64）：<pre>{certBytes}</pre>',
  'glpi.err.noPassiveAuthenticationCSCA': '护照的证书哈希无法在ICAO主列表中找到，导致"err.noPassiveAuthenticationCSCA"错误。',
  'glpi.err.unverifiedDoc': '无法检索被动身份验证的证书字节，导致"err.unverifiedDoc"错误。',
  'glpi.err.noPassiveAuthentication': '无法执行被动身份验证，导致"err.noPassiveAuthentication"错误。',
  'glpi.err.noConnect': '无法与护照芯片建立连接，导致"err.noConnect"错误。',
  'glpi.err.noBAC': '使用提供的MRZ信息无法建立BAC连接，触发"err.noBAC"错误。',
  'glpi.err.alteredDoc': '一个或多个条目的数据组哈希（DGS）不正确，导致"err.alteredDoc"错误。',
  'glpi.err.revokedDocSigner': '文件签发者的证书序列号出现在证书吊销列表（CRL）上，导致"err.revokedDocSigner"错误。',
  'watchlistCollapse': '<p>找到的观察名单 - <span class="watchlistCategories">{categories}</span></p>',
  'match.type': '匹配类型',
  'match.hair': '头发',
  'match.eyes': '眼睛',
  'match.height': '身高',
  'match.weight': '体重',
  'match.race': '种族',
  'global.category': '类别',
  'watchlist.alertLevel': '观察名单的警报级别',
  'watchlist.match': '匹配 {numberMatch} | <span class="watchlistCategories">{matchCategory}</span>',
  'Nationalities': '国籍 {index}',
  'global.score': '评分',
  'watchlist.name': '观察名单的名称',
  'alias': '别名 {index}',
  'document.number': '文件号码 {index}',
  'document.issuer': '文件签发者 {index}',
  'document.type': '文件类型 {index}',
  'dateOfBirth': '出生日期 {index}',
  'watchlist.marks': '标记',
  'watchlist.image.link': '找到的图像链接 {index}',
  'image.match': '图像匹配 {index}',
  'tooltip.watchlist': '此人的观察名单信息。',
  'watchList.category': '观察名单的类别',
  'watchlist.level': '警报级别',
  'scan.fingerprint.desc': '准备好后，点击下方按钮开始采集此人的指纹。当指纹设备的红灯亮起时，此人必须将食指放在扫描器上，官员会进行提示。',
  'scan.fingerprint.noResponse': '指纹扫描仪无响应。此人是否将手指放在扫描器上？设备是否已正确连接？',
  'scan.fingerprint': '指纹',
  'fingerprint.scan.start': '扫描指纹',
  'scan.fingerprint.success': '指纹已成功扫描。扫描指纹的质量为 {quality}/100。如果质量不够好，您可以重试此过程。',
  'fingerprint.notAvailable': '看起来指纹扫描仪不可用，或驱动程序未安装。您仍然可以在没有指纹的情况下继续签到。',
  'skip': '跳过',
  'global.checkOut.fingerprint': '使用指纹签退',
  'global.checkIn.fingerprint': '使用指纹签到',
  'tooltip.checkOut.fingerprint': '使用指纹为此人办理签退手续。',
  'tooltip.checkIn.fingerprint': '使用指纹为此人办理签到手续。',
  'paymentError.title': '订单问题',
  'DYN.paymentError.desc.fail': '很抱歉，支付失败。请重试。',
  'DYN.paymentError.desc.error': '很抱歉，支付处理返回错误。请联系我们',
  'DYN.paymentError.desc.later': '很抱歉，支付处理暂时被拒绝。请重试。',
  'tooltip.applicationId': '申请的ID。',
  'client.extended.missingResource': '您请求的资源当前不可用。请稍后再试。',
  'skip.valid': '自动跳过已审查的步骤',
  'extension.data': '延期数据',
  'attestantAddress': '证人地址',
  'attestantEmail': '证人的电子邮件',
  'attestantID': '证人的ID',
  'attestantName': '证人姓名',
  'attestantPhone': '证人电话',
  'attestantRelation': '与证人的关系',
  'daysRequested': '请求的天数',
  'tooltip.visaApplicationReference': '前往与此延期请求相关的申请',
  'extend.visaReference': '与此延期请求相关的申请',
  'data.copyOfEntry': '入境副本',
  'data.departureTicket': '离境机票',
  'data.attestantDocument': '证人的文件',
  'data.affidavitCustody': '监护声明书',
  'reasonForExtention': '延期原因',
  'final.ZWEVISAEXTAB': '此延期请求需要官员批准。',
  'zwevisaExtValid': '延期已验证',
  'zwevisaExtValid.desc': '此延期请求已由官员验证。',
  'zwevisaExtC.review.state': '等待审查',
  'zwevisaExtC.review.desc': '此延期请求等待审查。',
  'zwevisaExtC.finalReview.desc': '此延期请求已被审查，当前等待最终审查。',
  'zwevisaExtC.finalReview.state': '等待最终审查',
  'tooltip.tableLocalUsageUntil': '申请的到期日期指的是最长停留日期。',
  'ask.localUsageUntil.confirm': '您可以在此更改最长停留日期。您只能缩短日期。',
  'localUsageUntil.ask': '更改最长停留日期（可选）',
  'error.bad.localUsageUntil': '最长停留日期必须早于当前到期日期且晚于今天。',
  'none': '无',
  'change.password.ad': '由于您拥有活动目录帐户，您不能在此更改密码。欲了解更多信息，请联系支持。',
  'noticePrint.title': '已打印给客户的访客通知信息',
  'reportingPost': '报告岗位',
  'noticePrint.matTooltip': '在签到过程中打印给客户的访客通知信息',
  'notice.confirm': '您确定通知中的信息正确吗？',
  'global.refusePrint': '打印并提交',
  'global.nextPrint': '打印并继续',
  'err.periodFrom.periodFromGreaterThanPeriodTo': '开始时间必须早于结束时间。',
  'payment.reject_reason': '拒绝原因',
  'err.fileSize': '文件大小太大。最大大小为：{size}',
  'document.zafembpass': '南非大使馆护照',
  'preenroll': '预注册',
  'screen': '筛查',
  'pass': '护照',
  'document.pass': '护照',
  'document.screen': '筛查',
  'payment.ask.print': '收据已打印吗？',
  'global.no.retry': '否（重试）',
  'print.receipt': '打印收据',
  'tooltip.printReceipt': '打印申请的收据',
  'ask.printReceipt': '您要打印日期为{date}的收据吗？',
  'error.printReceipt': '打印收据时发生错误。请重试。',
  'ask.selectReceipt': '请选择您要打印的收据。',
  'operation.OUT': '签退',
  'operation.IN': '签到',
  'operation.PAYMENT_FINALIZED': '支付完成',
  'operation.PAYMENT_CREATED': '支付创建',
  'operation.PAYMENT_USED_FORCE': '支付已使用',
  'noChoice.selectedReceipt': '请选择要打印的收据。',
  'select.receipt': '选择收据',
  'receiptFor.alt': '收据',
  'paymentType': '支付类型',
  'totalAmount.alt': '总金额',
  'totalAmount': '总金额',
  'date': '日期',
  'client': '客户',
  'desc': '描述',
  'details': '详细信息',
  'client.extended.minUsageNotMet': '有效期至少应在有效期开始后一天。',
  'payment.assigned.warning': '此申请目前正在由另一名官员（官员：{officerId}）在24小时内使用。您是否仍想打开此申请？',
  'lock': '锁定',
  'tooltip.tableLockTitle': '官员的活动使用',
  'client.extended.uuidNotPaid': '付款尚未验证。请先验证付款再继续。',
  'form.operationComments': '操作说明',
  'borderPass.emit': '已签发边境通行证',
  'tooltip.borderPass': '边境通行证是允许没有护照的个人过境的文件。',
  'zweexit.title': '免签离境',
  'borderPass.title': '边境通行证',
  'print.borderPass': '打印边境通行证',
  'print.borderPass.ask': '边境通行证已打印吗？',
  'err.issueDate.afterExpiryDate': '签发日期必须早于到期日期。',
  'err.BirthDay.afterExpiryDate': '出生日期必须早于到期日期。',
  'err.BirthDay.afterIssueDate': '出生日期必须早于签发日期。',
  'apiPnrCollapse': '找到PNR',
  'apipnrResponse.match': '匹配{numberMatch}',
  'match.name': '名称',
  'match.score.name': '名称评分',
  'match.flightCarrier': '航班承运人',
  'match.flightNumber': '航班号',
  'match.documentType': '文件类型',
  'match.documentNumber': '文件编号',
  'match.documentIssuer': '文件签发者',
  'match.timeType': '事件类型',
  'match.timeDate': '事件日期',
  'match.timeScope': '事件范围',
  'match.nationality': '国籍',
  'match.gender': '性别',
  'match.uuid': 'UUID',
  'match.travelerUUID': '旅行者UUID',
  'tooltip.apiPnr': '找到的PNR信息。',
  'match.documentIssued': '文件签发日期',
  'match.placeIssued': '文件签发地点',
  'match.documentExpiration': '文件到期日期',
  'match.documentScore': '文件评分',
  'match.timeScore': '事件评分',
  'match.flightOriginDomestic': '航班国内起点',
  'match.flightOriginIcao': '航班起点ICAO代码',
  'match.flightOriginLat': '航班起点纬度',
  'match.flightOriginLng': '航班起点经度',
  'match.flightOriginIata': '航班起点IATA代码',
  'match.flightOriginCity': '航班起点城市',
  'match.flightOriginState': '航班起点州',
  'match.flightOriginCountry': '航班起点国家',
  'match.flightOriginContinent': '航班起点大陆',
  'match.flightOriginName': '航班起点名称',
  'match.flightOriginTimezone': '航班起点时区',
  'match.flightDestinationDomestic': '航班国内目的地',
  'match.flightDestinationIcao': '航班目的地ICAO代码',
  'match.flightDestinationLat': '航班目的地纬度',
  'match.flightDestinationLng': '航班目的地经度',
  'match.flightDestinationIata': '航班目的地IATA代码',
  'match.flightDestinationCity': '航班目的地城市',
  'match.flightDestinationState': '航班目的地州',
  'match.flightDestinationCountry': '航班目的地国家',
  'match.flightDestinationContinent': '航班目的地大陆',
  'match.flightDestinationName': '航班目的地名称',
  'match.flightDestinationTimezone': '航班目的地时区',
  'match.localDepartureDate': '本地出发日期',
  'match.localDepartureTime': '本地出发时间',
  'match.localDepartureTotalMinutes': '本地出发总分钟数',
  'match.localDepartureDay': '本地出发日',
  'match.localDepartureZone': '本地出发区域',
  'match.airportDepartureDate': '机场出发日期',
  'match.airportDepartureTime': '机场出发时间',
  'match.airportDepartureTotalMinutes': '机场出发总分钟数',
  'match.airportDepartureDay': '机场出发日',
  'match.airportDepartureZone': '机场出发区域',
  'match.utcDepartureDate': 'UTC出发日期',
  'match.utcDepartureTime': 'UTC出发时间',
  'match.utcDepartureTotalMinutes': 'UTC出发总分钟数',
  'match.utcDepartureDay': 'UTC出发日',
  'match.utcDepartureZone': 'UTC出发区域',
  'match.originalDeparture': '原始出发',
  'match.flightDepartureUtcstr': '航班UTC出发',
  'match.localArrivalDate': '本地到达日期',
  'match.localArrivalTime': '本地到达时间',
  'match.localArrivalTotalMinutes': '本地到达总分钟数',
  'match.localArrivalDay': '本地到达日',
  'match.localArrivalZone': '本地到达区域',
  'match.airportArrivalDate': '机场到达日期',
  'match.airportArrivalTime': '机场到达时间',
  'match.airportArrivalTotalMinutes': '机场到达总分钟数',
  'match.airportArrivalDay': '机场到达日',
  'match.airportArrivalZone': '机场到达区域',
  'match.utcArrivalDate': 'UTC到达日期',
  'match.utcArrivalTime': 'UTC到达时间',
  'match.utcArrivalTotalMinutes': 'UTC到达总分钟数',
  'match.utcArrivalDay': 'UTC到达日',
  'match.utcArrivalZone': 'UTC到达区域',
  'match.originalArrival': '原始到达',
  'match.flightArrivalUtcstr': '航班UTC到达',
  'match.flightBound': '航班方向',
  'ask.notice': '打印访客通知或临时限制通知',
  'tooltip.checkIn.notice': '为此人办理入境并打印访客通知或临时限制通知。',
  'global.checkIn.notice': '带通知的签到',
  'event.downgrade': '此申请已从{previousPayment}降级为{newPayment}，时间为{date}，用户{userId}。',
  'form.numberPeople': '与申请人同行的人数',
  'feedbackForm': '反馈表',
  'form.totalSpend': '停留期间的总花费',
  'countryPermanentResidence': '永久居住国',
  'form.feedbackComments': '附加评论',
  'feedback.submit': '提交反馈',
  'feedback.submitted': '反馈已成功提交。',
  'residencePermit.warning': '数据库中未找到居留许可号码<b>{permitNumber}</b>。<br><br>请在批准入境前，手动核对该号码与旅客的实体居留许可。',
  'statusLabel.toConfirm': '（待确认）',
  'form.lang.IT': 'Italiano',
  'form.lang.JA': '日本語',
  'form.birthCity': '出生城市',
  'form.eyeColor': '眼睛颜色',
  'form.hairColor': '头发颜色',
  'form.height': '身高',
  'form.occupation': '职业',
  'form.fatherFirstName': '父亲的名字',
  'form.fatherLastName': '父亲的姓氏',
  'form.motherFirstName': '母亲的名字',
  'form.motherLastName': '母亲的姓氏',
  'form.physical.description': '身体描述',
  'documents.no.documents': '未找到此应用程序的文档',
  'OtherPurpose': '其他目的',
  'form.seniority.ownPlace': '仅限自有房产',
  'form.seniority.allPlaces': '所有地方',
  'nav.searchFromDocument': '从文件中搜索',
  'tooltip.nextApplication': '加载下一个需要处理的申请',
  'nextApplication.button': '处理下一个申请',
  'error.insufficientPermissions': '权限不足，无法访问此功能',
  'nextApplication.noMore': '没有更多申请需要处理',
  'nextApplication.error': '加载下一个申请时出错',
  'document.Preview': '预览',
  'traveller.history.title': '旅客历史',
  'traveller.history.loading': '正在加载历史记录…',
  'traveller.history.entry_exit': '入境 / 出境',
  'traveller.history.compliance': '合规',
  'traveller.history.view_more': '查看更多',
  'traveller.history.collapse': '收起',
  'traveller.history.no_records': '未找到记录',
  'traveller.history.records': '条记录',
  'traveller.history.user': '用户',
  'traveller.history.reason': '原因',
  'traveller.history.additional_info': '附加信息',
  'traveller.history.event.ENTERED_COUNTRY': '入境',
  'traveller.history.event.EXITED_COUNTRY': '出境',
  'traveller.history.event.DEPORTATION_CREATED': '驱逐已创建',
  'traveller.history.event.DEPORTATION_EDITED': '驱逐已编辑',
  'traveller.history.event.DEPORTATION_APPROVED_BY_SUPERVISOR': '驱逐已由主管批准',
  'traveller.history.event.DEPORTATION_APPROVED_BY_DIR_OPS': '驱逐已由运营总监批准',
  'traveller.history.event.SUCCESSFULLY_DEPORTED': '驱逐成功',
  'traveller.history.event.DEPORTATION_DECLINED': '驱逐被拒绝',
  'traveller.history.event.ADDED_TO_WATCHLIST': '已添加到监视名单',
  'traveller.history.event.REMOVED_FROM_WATCHLIST': '已从监视名单移除',
  'traveller.history.event.PROSECUTION_CREATED': '起诉已创建',
  'traveller.history.event.ADDED_BIOMETRIC': '已添加生物特征',
  'traveller.history.event.INTERVIEW_CREATED': '面谈已创建',
  'traveller.history.event.INTERVIEW_EDITED': '面谈已编辑',
  'traveller.history.event.REFUGEE_RECORD_CREATED': '难民记录已创建',
  'traveller.history.event.REFUGEE_RECORD_EDITED': '难民记录已编辑',
  'traveller.history.visa': '签证',
  'traveller.history.event.VALIDATED': '已批准',
  'traveller.history.event.REFUSED': '已拒绝',
  'traveller.history.permits': '许可证',
  'traveller.history.permit.ORDINARY_RESIDENCE_PERMIT': '普通居留许可',
  'traveller.history.permit.SPOUSE_RESIDENCE_PERMIT': '配偶居留许可',
  'traveller.history.permit.INVESTOR_RESIDENCE_PERMIT': '投资者居留许可',
  'traveller.history.permit.STUDENTS_PERMIT': '学生许可',
  'traveller.history.permit.SCHOLARS_PERMIT': '学者许可',
  'traveller.history.permit.TEMPORARY_EMPLOYMENT_PERMIT': '临时工作许可',
  'traveller.history.permit.AUTHORITY_TO_WORK': '工作授权',
  'traveller.history.permit.RESUMPTION': '恢复',
  'traveller.history.permit.DUAL_CITIZENSHIP': '双重国籍',
  'traveller.history.permit.REINSTATEMENT': '复职',
  'traveller.history.permit.applicationType': '申请类型',
  'traveller.history.permit.appType.INITIAL': '初始',
  'traveller.history.permit.appType.EXTENSION': '延期',
  'traveller.history.permit.appType.PERMANENT': '永久',
  'traveller.history.permit.status.REQUESTED': '已申请',
  'traveller.history.permit.status.APPROVED': '已批准',
  'traveller.history.permit.status.REJECTED': '已拒绝',
  'traveller.history.permit.issueDate': '签发日期',
  'traveller.history.permit.expiryDate': '到期日期',
  'showcase.heroTitle': '快速、安全且<em>数字化</em><br/>电子签证体验。',
  'showcase.heroSubtitle': '几分钟内完成申请、验证并出行。{name} 将生物特征身份与政府级决策引擎相结合——让您的批准在您到达之前就已就位。',
  'showcase.heroSubtitle.evisa': '几分钟内完成申请、验证并出行。{name} 将生物特征身份与政府级决策引擎相结合——让您的批准在您到达之前就已就位。',
  'showcase.heroSubtitle.passport_idCard_residencePermit': '在线申请护照、身份证或居留许可。{name} 实时处理和跟踪每个申请，从提交到交付。',
  'showcase.heroSubtitle.passport_idCard': '在线申请护照或身份证。{name} 实时处理和跟踪每个申请。',
  'showcase.heroSubtitle.passport': '在线申请护照。{name} 实时处理和跟踪每个申请，从提交到交付。',
  'showcase.heroSubtitle.idCard': '在线申请身份证。{name} 实时处理和跟踪每个申请。',
  'showcase.heroSubtitle.residencePermit': '在线申请居留许可。{name} 实时处理和跟踪每个申请。',
  'showcase.heroSubtitle.passport_residencePermit': '在线申请护照或居留许可。{name} 实时处理和跟踪每个申请。',
  'showcase.heroSubtitle.idCard_residencePermit': '在线申请身份证或居留许可。{name} 实时处理和跟踪每个申请。',
  'showcase.heroCta1': '申请电子签证',
  'showcase.heroCta2': '跟踪申请',
  'showcase.flowTitleMain': '四个步骤。<br/><em>零等待。</em>',
  'showcase.flowTitleSub': '随您同行的申请。',
  'showcase.flowSubtitle': '{name} 将您申请的四个环节整合为一个流畅的流程——系统处理文件，您只需打包行李。',
  'showcase.ctaTitle': '开启您的旅程<br/><em>数字化出行。</em>',
  'showcase.ctaSubtitle': '一次申请。电子签证存于您的口袋，决定在您到达之前送达。',
  'showcase.step1.label': '创建申请',
  'showcase.step1.paneTitle': '填写您的信息',
  'showcase.step1.paneDesc': '目的地、出行日期、访问目的和入境口岸…',
  'showcase.step2.label': '上传文件',
  'showcase.step2.paneTitle': '上传您的护照',
  'showcase.step2.paneDesc': '护照扫描、MRZ 读取、即时字段提取…',
  'showcase.step3.label': '生物特征验证',
  'showcase.step3.paneTitle': '活体检测与人脸匹配',
  'showcase.step3.paneDesc': '活体检测、人脸匹配和制裁筛查…',
  'showcase.step4.label': '即时审批',
  'showcase.step4.paneTitle': '已批准，可过境',
  'showcase.step4.paneDesc': '您的电子签证已签署、封存并同步至您的钱包…',
  'showcase.stat1.value': '加密',
  'showcase.stat1.label': '端到端',
  'showcase.stat2.value': '认证',
  'showcase.stat2.label': '安全平台',
  'showcase.portalType': '电子签证门户',
  'showcase.tl.step1': '身份',
  'showcase.tl.step3': '决定',
  'showcase.tl.step4': '出行',
  'showcase.tl.step2': '文件',
  'showcase.evisa.ministry': '外交部',
  'showcase.marquee.issuedBy': '由主权机构颁发',
  'showcase.marquee.biometric': '生物特征',
  'showcase.marquee.secured': '已保护',
  'showcase.marquee.borderReady': '几分钟内通关就绪',
  'showcase.marquee.encrypted': '端到端加密',
  'showcase.marquee.eSeal': '合格电子印章',
  'showcase.marquee.realtime': '实时跟踪',
  'showcase.annot.mrz': 'MRZ已验证',
  'showcase.annot.biometric': '生物特征',
  'showcase.annot.issued': '已签发',
  'showcase.annot.secured': '已保护',
  'showcase.howItWorks': '如何使用',
  'showcase.signIn': '登录我的账户',
  'showcase.scroll': '滚动',
  'showcase.permit.badge': '居民',
  'showcase.permit.title': '许可',
  'showcase.permit.name': '居留证',
  'finger.thumb': '拇指',
  'finger.index': '食指',
  'finger.middle': '中指',
  'finger.ring': '无名指',
  'finger.little': '小指',
  'finger.missing': '缺失',
  'hand.left': '左手',
  'hand.right': '右手',
  'fingerprints': '指纹',
  'finger.thumbs': '拇指',
  'fingers.missing': '缺失的手指',
  'signature': '签名',
  'print.withdrawal.date': '提取日期',
  'trips.helper': '点击查看/下载二维码'
};
